import {ActivityEndType} from '../backend/enums/activity-end-type';
import {AffiliationType} from '../backend/enums/affiliation-type';
import {BackendLanguageTag} from '../backend/enums/backend-language-tag';
import {CameraFacing} from '../backend/enums/camera-facing';
import {CaregiverRelationshipRole} from '../backend/enums/caregiver-relationship-role';
import {DeviceType} from '../backend/enums/device-type';
import {EntitySpecialPurpose} from '../backend/enums/entity-special-purpose';
import {EntityType} from '../backend/enums/entity-type';
import {InviteState} from '../backend/enums/invite-state';
import {PlaylistType} from '../backend/enums/playlist-type';
import {MobileNetworkType} from '../backend/enums/mobile-network-type';
import {OperativeSystemName} from '../backend/enums/operative-system-name';
import {ProcessStatus} from '../backend/enums/process-status';
import {RegionCode} from '../backend/enums/region-code';
import {RelationshipType} from '../backend/enums/relationship-type';
import {ReminderResponseValue} from '../backend/enums/reminder-response-value';
import {UserGender} from '../backend/enums/user-gender';
import {UserSignInType} from '../backend/enums/user-sign-in-type';
import {UserType} from '../backend/enums/user-type';
import {InviteContactMethod} from '../enums/invite-contact-method';
import {SignInError} from '../enums/sign-in-error';
import {TimeLapseType} from '../enums/time-lapse-type';
import {LanguageTranslation} from './types';
import {Religion} from '../backend/enums';
import {CaregiverTaskCompletion} from '../enums/caregiver-task-completion';
import {CareTaskNotDoneReason} from '../backend/enums/care-task-not-done-reason';
import {CareTaskFeature} from '../backend/enums/care-task-feature';
import {RolePermissionType} from '../backend/enums/role-permission-type';
import {PosologySchedule} from '../backend/enums/posology-schedule';
import {Frequency} from '../types';
import {MaritalStatus} from '../backend/enums/marital-status';
import {EducationLevel} from '../backend/enums/education-level';

function writePaths(propertyValue: any, path: Array<string>): any {
  // Evaluate
  if (typeof propertyValue === 'object' && propertyValue !== null) {
    // Start building a new object
    const result: any = {};

    // Get all properties
    const keys: Array<string> = Object.keys(propertyValue);

    // For each property
    for (let key of keys) {
      // Execute this same process
      result[key] = writePaths(propertyValue[key], [...path, key]);
    }

    // Ready to return
    return result;
  } else {
    // It is not an object, so it's time to write the path
    return `${path.join('.')}`;
  }
}

const _translations: LanguageTranslation = {
  family_applications: {
    title: '',
    entity: '',
    choose_entity: '',
    no_affiliations: '',
    missing_affiliations: '',
    load_error: '',
    retry: '',
    more: '',
    back: '',
    access: '',
    enabled: '',
    disabled: '',
    enable: '',
    disable: '',
    confirm: '',
    write_error: '',
    write_success: '',
  },
  reminders: {
    group_time: '',
    group_reminder: '',
    group_repeats: '',
    group_recipients: '',
    group_actions: '',
    no_entity_assigned: '',
    group_switch_entity: '',
    group_edit: '',
    group_delete: '',
    group_delete_confirm: '',
    group_partial: '',
    group_future_required: '',
    group_advanced: '',
    my_title: '',
    my_scope: '',
    creation_scope: '',
    recipient: '',
    title: '',
    subtitle: '',
    add: '',
    bulk_title: '',
    bulk_success: '',
    bulk_partial: '',
    edit: '',
    loading: '',
    empty_title: '',
    empty_description: '',
    load_more: '',
    retry: '',
    load_error: '',
    senior_unavailable: '',
    delete_title: '',
    delete_description: '',
    delete: '',
    cancel: '',
    enable: '',
    disable: '',
    status_active: '',
    status_inactive: '',
    next_run: '',
    save_error: '',
    save_success: '',
    delete_error: '',
    delete_success: '',
    active_error: '',
    active_success: '',
    inactive_success: '',
    response_types: {
      yes_no: '',
      ok: '',
    },
    recurrence: {
      once: '',
      per_minute: '',
      hourly: '',
      daily: '',
      weekly: '',
      monthly: '',
      yearly: '',
      current_unsupported: '',
    },
    form: {
      title: '',
      title_placeholder: '',
      message: '',
      message_placeholder: '',
      response_type: '',
      date: '',
      time: '',
      recurrence: '',
      recurrence_count: '',
      save: '',
      title_required: '',
      title_too_long: '',
      message_required: '',
      message_too_long: '',
      date_required: '',
      time_required: '',
      invalid_date_time: '',
      date_in_past: '',
      time_in_past: '',
    },
  },
  family_services: {
    title: '',
    choose: '',
    none: '',
    unavailable: '',
    empty: '',
    error: '',
    denied: '',
    not_found: '',
    retry: '',
    call: '',
    no_phone: '',
    unsupported: '',
    active: '',
    inactive: '',
    enable: '',
    disable: '',
    confirm: '',
    cancel: '',
    save_error: '',
    saved: '',
    refresh_error: '',
  },
  family_invite: {
    contact_method: '',
    phone: '',
    action: '',
    context: '',
    name: '',
    email: '',
    next: '',
    back: '',
    send: '',
    confirm: '',
    success: '',
    uncertain: '',
    invalid: '',
    denied: '',
    unavailable: '',
  },
  family_profile: {
    user_details: '',
    remove_link: '',
    remove_link_success: '',
    remove_link_confirm: '',
    remove_link_error: '',
    remove_link_denied: '',
    cancel: '',
    institutions: '',
    senior_contacts: '',
    senior_empty: '',
    title: '',
    contacts: '',
    empty: '',
    load_more: '',
    loading: '',
    error: '',
    denied: '',
    unavailable: '',
    retry: '',
    close: '',
  },
  family_media: {
    recording: '',
    camera: '',
    take_photo: '',
    record_video: '',
    stop_recording: '',
    camera_error: '',
    title: '',
    download: '',
    share: '',
    export_error: '',
    upload: '',
    refresh: '',
    loading: '',
    empty_title: '',
    empty_description: '',
    load_error: '',
    refresh_error: '',
    load_more: '',
    loading_more: '',
    retry: '',
    senior_unavailable: '',
    photo: '',
    video: '',
    processing: '',
    processing_failed: '',
    uploaded_by: '',
    you: '',
    created_at: '',
    description: '',
    edit: '',
    delete: '',
    cancel: '',
    save: '',
    saving: '',
    upload_photo: '',
    upload_progress: '',
    invalid_file_type: '',
    upload_request_error: '',
    upload_transfer_error: '',
    upload_record_error: '',
    upload_success: '',
    edit_success: '',
    edit_error: '',
    router_prompt_edit_title: '',
    router_prompt_edit_message: '',
    delete_success: '',
    delete_error: '',
    delete_confirm_title: '',
    delete_confirm_description: '',
    detail_not_found: '',
    detail_load_error: '',
    detail_unavailable: '',
    signed_url_error: '',
  },
  legal_documents: {
    terms_and_conditions: '',
    privacy_policy: '',
  },
  products: {
    bluebird: '',
    bluebird_with_gender: '',
  },
  relationship_types: {
    [RelationshipType.Family]: '',
    [RelationshipType.Friend]: '',
    [RelationshipType.Healthcare]: '',
    [RelationshipType.Service]: '',
    [RelationshipType.Other]: '',
  },
  user_types: {
    [UserType.Caregiver]: '',
    [UserType.Follower]: '',
    [UserType.Senior]: '',
  },
  genders: {
    [UserGender.Female]: '',
    [UserGender.Male]: '',
    [UserGender.Undisclosed]: '',
    [UserGender.Unspecified]: '',
  },
  marital_statuses: {
    [MaritalStatus.CivilUnion]: '',
    [MaritalStatus.Divorced]: '',
    [MaritalStatus.Married]: '',
    [MaritalStatus.Other]: '',
    [MaritalStatus.Single]: '',
    [MaritalStatus.Widowed]: '',
  },
  education_levels: {
    [EducationLevel.BachelorsDegree]: '',
    [EducationLevel.BasicEducation]: '',
    [EducationLevel.DoctoratePhd]: '',
    [EducationLevel.MastersDegree]: '',
    [EducationLevel.NoFormalEducation]: '',
    [EducationLevel.Other]: '',
    [EducationLevel.PostgraduateDiploma]: '',
    [EducationLevel.PrimaryEducation]: '',
    [EducationLevel.SecondaryEducation]: '',
    [EducationLevel.VocationalTechnicalTraining]: '',
  },
  languages: {
    [BackendLanguageTag.ptPT]: '',
    [BackendLanguageTag.enUS]: '',
    [BackendLanguageTag.esES]: '',
    [BackendLanguageTag.glES]: '',
    [BackendLanguageTag.ptBR]: '',
  },
  regions: {
    [RegionCode.PT]: '',
    [RegionCode.ES]: '',
    [RegionCode.GL]: '',
    [RegionCode.BR]: '',
  },
  roles: {
    [CaregiverRelationshipRole.Administrator]: '',
    [CaregiverRelationshipRole.Contact]: '',
    [CaregiverRelationshipRole.Member]: '',
  },
  religions: {
    [Religion.AfricanTraditionalAndDiasporic]: '',
    [Religion.Agnostic]: '',
    [Religion.Animism]: '',
    [Religion.Atheist]: '',
    [Religion.BahaI]: '',
    [Religion.Buddhism]: '',
    [Religion.CaoDai]: '',
    [Religion.ChineseTraditionalReligion]: '',
    [Religion.Christianity]: '',
    [Religion.Hinduism]: '',
    [Religion.Islam]: '',
    [Religion.Jainism]: '',
    [Religion.Juche]: '',
    [Religion.Judaism]: '',
    [Religion.NeoPaganism]: '',
    [Religion.Nonreligious]: '',
    [Religion.Rastafari]: '',
    [Religion.Secular]: '',
    [Religion.Shinto]: '',
    [Religion.Sikhism]: '',
    [Religion.Spiritism]: '',
    [Religion.Tenrikyo]: '',
    [Religion.UnitarianUniversalism]: '',
    [Religion.Zoroastrianism]: '',
    [Religion.PrimalIndigenous]: '',
    [Religion.Undisclosed]: '',
    [Religion.Unspecified]: '',
  },
  affiliation_types: {
    [AffiliationType.Senior]: '',
    [AffiliationType.Caregiver]: '',
    [AffiliationType.Administrator]: '',
    [AffiliationType.Manager]: '',
    [AffiliationType.Operator]: '',
    [AffiliationType.MedicalProfessional]: '',
  },
  role_permissions_section: {
    overview: '',
    seniors: '',
    team: '',
    'digital-inclusion': '',
    settings: '',
    'daily-care-log': '',
    calendar: '',
    occurrences: '',
    'quick-access-devices': '',
  },
  role_permissions: {
    [RolePermissionType.Overview_Activity]: '',
    [RolePermissionType.Overview_Statistics]: '',
    [RolePermissionType.Seniors_List]: '',
    [RolePermissionType.Seniors_Dashboard]: '',
    [RolePermissionType.Seniors_Dashboard_GeneralStatistics]: '',
    [RolePermissionType.Seniors_Dashboard_HealthStatistics]: '',
    [RolePermissionType.Seniors_IndividualPlan]: '',
    [RolePermissionType.Seniors_PersonalData_Reminders]: '',
    [RolePermissionType.Seniors_BADL]: '',
    [RolePermissionType.Seniors_IADL]: '',
    [RolePermissionType.Seniors_ClinicalSupport]: '',
    [RolePermissionType.Seniors_PersonalDevelopment]: '',
    [RolePermissionType.Seniors_CareAndActivities]: '',
    [RolePermissionType.Seniors_CareAndActivities_BADL]: '',
    [RolePermissionType.Seniors_CareAndActivities_IADL]: '',
    [RolePermissionType.Seniors_CareAndActivities_PersonalDevelopment]: '',
    [RolePermissionType.Seniors_CareAndActivities_ClinicalSupport]: '',
    [RolePermissionType.Seniors_CareServices]: '',
    [RolePermissionType.Seniors_PersonalData_Profile]: '',
    [RolePermissionType.Seniors_PersonalData_Caregivers]: '',
    [RolePermissionType.Seniors_PersonalData_Health]: '',
    [RolePermissionType.Seniors_DigitalInclusion_Applications]: '',
    [RolePermissionType.Seniors_DigitalInclusion_Devices]: '',
    [RolePermissionType.Seniors_DigitalInclusion_Playlists]: '',
    [RolePermissionType.Seniors_DigitalInclusion_Cards]: '',
    [RolePermissionType.Seniors_PersonalData_Attachments]: '',
    [RolePermissionType.Seniors_Dashboard_Activity]: '',
    [RolePermissionType.Team_Professionals]: '',
    [RolePermissionType.Team_CareServices]: '',
    [RolePermissionType.Team_Professionals_Profile]: '',
    [RolePermissionType.Team_Professionals_Applications]: '',
    [RolePermissionType.Team_Professionals_Cards]: '',
    [RolePermissionType.Team_Professionals_Playlists]: '',
    [RolePermissionType.Team_Professionals_CareServices]: '',
    [RolePermissionType.Team_Shifts_Management]: '',
    [RolePermissionType.Team_Shifts_Attributions]: '',
    [RolePermissionType.Team_Permissions]: '',
    [RolePermissionType.Team_AttendanceTracker_Registry]: '',
    [RolePermissionType.Team_AttendanceTracker_Assignments]: '',
    [RolePermissionType.Settings_Entity_Profile]: '',
    [RolePermissionType.Settings_Entity_Settings]: '',
    [RolePermissionType.Settings_Licenses]: '',
    [RolePermissionType.Settings_BADL]: '',
    [RolePermissionType.Settings_IADL]: '',
    [RolePermissionType.Settings_ClinicalSupport]: '',
    [RolePermissionType.Settings_PersonalDevelopment]: '',
    [RolePermissionType.Settings_Templates]: '',
    [RolePermissionType.Settings_Occurrences]: '',
    [RolePermissionType.DailyCareLog]: '',
    [RolePermissionType.DailyCareLog_BADL]: '',
    [RolePermissionType.DailyCareLog_IADL]: '',
    [RolePermissionType.DailyCareLog_PersonalDevelopment]: '',
    [RolePermissionType.DailyCareLog_ClinicalSupport]: '',
    [RolePermissionType.DailyCareLog_Occurrences]: '',
    [RolePermissionType.DigitalInclusion_Applications]: '',
    [RolePermissionType.DigitalInclusion_Media]: '',
    [RolePermissionType.DigitalInclusion_Devices]: '',
    [RolePermissionType.DigitalInclusion_Cards]: '',
    [RolePermissionType.DigitalInclusion_Playlists]: '',
    [RolePermissionType.DigitalInclusion_Services]: '',
    [RolePermissionType.Calendar]: '',
    [RolePermissionType.Calendar_BADL]: '',
    [RolePermissionType.Calendar_IADL]: '',
    [RolePermissionType.Calendar_PersonalDevelopment]: '',
    [RolePermissionType.Calendar_ClinicalSupport]: '',
    [RolePermissionType.Occurrences]: '',
    [RolePermissionType.SettingsQuickAccessDevices]: '',
  },
  screen_paths: {
    professional_caregiver_seniors: '',
    professional_caregiver_team: '',
    professional_caregiver_roles_and_permissions: '',
    senior_dashboard: '',
    senior_individual_plan: '',
    senior_care_plan: '',
    senior_care_and_activity: '',
    senior_personal_data: '',
    senior_profile: '',
    senior_caregivers: '',
    senior_applications: '',
    senior_devices: '',
    senior_activity: '',
    senior_user_cards: '',
    senior_statistics: '',
    senior_health: '',
    senior_playlists: '',
    senior_attachments: '',
    institution_settings_profile: '',
    institution_settings_settings: '',
    institution_settings_activity: '',
    institution_settings_user_cards: '',
    institution_settings_devices: '',
    institution_settings_services: '',
    institution_settings_playlist: '',
    institution_settings_statistics: '',
    institution_settings_licenses: '',
    institution_settings_templates: '',
    institution_settings_occurrences: '',
    institution_settings_quick_access_devices: '',
  },
  institution_settings_screen: {
    subtitle: {
      write: '',
      read: '',
    },
    columns: {
      setting: '',
      active: '',
    },
    attendance_tracker: '',
    load_error_toast: '',
    update_error_toast: '',
  },
  attendance_tracker_registry_screen: {
    subtitle: '',
    filters: {
      all_statuses: '',
      all_day: '',
      all_professionals: '',
    },
    empty: '',
    load_error: '',
    retry: '',
    waiting_exit: '',
    add: {
      title: '',
      professional: '',
      professionals_hint: '',
      professionals_empty: '',
      professional_placeholder: '',
      kind_label: '',
      kind_session: '',
      kind_entry: '',
      kind_exit: '',
      open_session_info: '',
      entry_date: '',
      entry_time: '',
      exit_date: '',
      exit_time: '',
      reason: '',
      reason_placeholder: '',
      notice: '',
      self_warning: '',
      self_action: '',
      cancel: '',
      continue: '',
      back: '',
      confirm: '',
      confirm_title: '',
      confirm_description: '',
      summary_record: '',
      success: '',
      checking: '',
      error_future: '',
      error_order: '',
      error_overlap: '',
      error_type: '',
      error_conflict: '',
      error_not_tracking: '',
      error_generic: '',
      validation_future: '',
      validation_exit_before_entry: '',
      validation_exit_before_open_entry: '',
      validation_reason_required: '',
    },
    void: {
      title: '',
      description: '',
      reason: '',
      reason_placeholder: '',
      cancel: '',
      confirm: '',
      success: '',
      error_conflict: '',
      error_self: '',
      error_generic: '',
      validation_reason_required: '',
    },
    correct: {
      title: '',
      description: '',
      current_session: '',
      reason: '',
      notice: '',
      confirm_title: '',
      confirm_description: '',
      summary_old: '',
      summary_new: '',
      confirm: '',
      success: '',
    },
    details: {
      correct_action: '',
      void_action: '',
      duration: '',
      title: '',
      close: '',
    },
  },
  attendance_tracker_assignments_screen: {
    subtitle: {
      write: '',
      read: '',
    },
    columns: {
      professional: '',
      assignment: '',
      last_change: '',
    },
    assignment_types: {
      mandatory: '',
      optional: '',
      not_applicable: '',
    },
    empty: '',
    last_change_summary: '',
    last_change_summary_no_author: '',
    load_error_toast: '',
    update_error_toast: '',
  },
  date_time_picker: {
    cancel_button: '',
    confirm_button: '',
    clear_button: '',
    today: '',
  },
  date_range_input: {
    title: '',
    ok_button: '',
    cancel_button: '',
    presets: {
      day: '',
      week: '',
      month: '',
      '7_days': '',
      '15_days': '',
      '30_days': '',
      '180_days': '',
      '365_days': '',
      custom: '',
    },
    errors: {
      invalid_date_range: '',
    },
  },
  generic_header: {
    actions: {
      edit: '',
      delete: '',
      save: '',
      import: '',
      archivePlan: '',
      remove: '',
    },
  },
  user_card: {
    actions: {
      edit: '',
      delete: '',
    },
  },
  role_autocomplete: {
    unselected: '',
    no_matching: '',
  },
  view_type_toggler: {
    tooltip_message: '',
  },
  index_grid_screen: {
    total_counter: '',
    add_button: '',
    search_placeholder: '',
    filter_placeholder: '',
    empty_message_add_encouraging: '',
    empty_search_message: {
      title: '',
      subtitle: '',
    },
    empty_filters_message: {
      title: '',
      subtitle: '',
    },
    toggler: {
      grid: '',
      list: '',
    },
  },
  login: {
    welcome: '',
    welcome_daily_care_log: '',
    welcome_accept_invite: '',
    instruction: '',
    email_input: '',
    password_input: '',
    enter_button: '',
    enter_button_microsoft: '',
    enter_button_google: '',
    forgot_password: '',
    quick_access: '',
    validate_invite: '',
    use_invite_code: '',
    errors: {
      form_validation_invalid_field: '',
      [SignInError.Unknown]: '',
      [SignInError.InvalidEmail]: '',
      [SignInError.UserDisabled]: '',
      [SignInError.UserNotFound]: '',
      [SignInError.WrongPassword]: '',
      [SignInError.FailedToGetMe]: '',
    },
  },
  recover_password: {
    title: '',
    subtitle: '',
    instructions: '',
    email_input: '',
    send_button: '',
    password_remembered: '',
    go_back_button: '',
    errors: {
      form_validation_invalid_field: '',
      send_request_error_message: '',
    },
    success: {
      send_request_success_message: '',
    },
  },
  replace_password: {
    title: '',
    instructions: '',
    new_password_input: '',
    repeat_password_input: '',
    submit_button: '',
    password_remembered: '',
    go_back_button: '',
    errors: {
      form_validation_invalid_field: '',
      form_validation_invalid_password_minimum_characters: '',
      form_validation_invalid_password_blank_spaces: '',
      form_validation_invalid_repeat_password_mismatch: '',
      change_password_error_message: '',
    },
    success: {
      change_password_success_message: '',
    },
  },
  validate_invite: {
    title: '',
    instructions_1: '',
    instructions_2: '',
    code_input: '',
    send_button: '',
    errors: {
      form_validation_invalid_field: '',
      invalid_invite_error_message: '',
    },
  },
  accept_invite: {
    relationship_invite_title: '',
    relationship_invite_instructions: '',
    affiliation_invite_title: '',
    affiliation_invite_instructions: '',
    affiliation_type_description: '',
    create_account_button: '',
    login_button: '',
    errors: {
      invalid_invite_error_message: '',
    },
  },
  quick_access_login: {
    instruction: '',
    all_users: '',
    error: '',
    back_to_email_and_password_login: '',
    go_back_to_the_recent_users_list: '',
    hello_user: '',
    insert_your_quick_access_code: '',
    login_failed: '',
    login_failed_code: '',
    try_again: '',
    regain_access: '',
    remove_recent: '',
    regain_access_message: '',
    regain_access_description: '',
    back_to_previous: '',
  },
  notifications: {
    date: '',
    time: '',
    title: '',
    check_read: '',
    check_unread: '',
    read_all_notifications: '',
    read_all_notifications_dialog_title: '',
    read_all_notifications_dialog_content: '',
    read_all_notifications_disabled_tooltip_message: '',
    read_all_notifications_success_message: '',
    read_all_notifications_error_message: '',
  },
  push_notifications: {
    warnings: {
      unsubscribed_generic_warning_title: '',
      unsubscribed_not_supported_warning_message: '',
      unsubscribed_error_warning_message: '',
      unsubscribed_permissions_denied_warning_message: '',
    },
  },
  invite_modal: {
    caregiver_invite_title: '',
    affiliation_type_description: '',
    relationship_type_input: '',
    invite_recipient_not_current_user_description: '',
    accept_button: '',
    decline_button: '',
    relationship_already_exists_description: '',
    affiliation_already_exists_description: '',
    invite_done_unknown_description: '',
    invite_done_refused_description: '',
    invite_done_accepted_description: '',
    invite_done_cancelled_description: '',
    invite_done_expired_description: '',
    loading_invite_description_1: '',
    loading_invite_description_2: '',
    errors: {
      refuse_invite_error_message: '',
      accept_invite_error_message: '',
      fetch_invite_error_message: '',
      fetch_invite_invalid_error_message: '',
    },
    success: {
      refuse_relationship_invite_success_message: '',
      accept_relationship_invite_success_message: '',
      refuse_affiliation_invite_success_message: '',
      accept_affiliation_invite_success_message: '',
    },
  },
  profile: {
    title: '',
    exit_button: '',
    personal_information_section_title: '',
    change_theme_section_title: '',
    legal_information_section_title: '',
    relationships_section_title: '',
    affiliations_section_title: '',
    logout_normal_button: '',
    logout_loading_button: '',
    logout_error_button: '',
    theme_input: '',
    dark_option: '',
    light_option: '',
    system_option: '',
  },
  create_caregiver_account: {
    register_title: '',
    essential_information_step_description: '',
    essential_information_step: '',
    personal_information_step: '',
    optional_information_step: '',
    note_title: '',
    note_statement: '',
    continue_button: '',
    create_account_button: '',
    start_using_button: '',
    go_back_to_login_button: '',
    go_back_button: '',
    success_title: '',
    success_description: '',
    error_title: '',
    error_description: '',
    relationship_type_input: '',
    profession_input: '',
    profession_description_input: '',
    email_address_input: '',
    password_input: '',
    repeat_password_input: '',
    legal_documents_title: '',
    legal_documents_statement: '',
    full_name_input: '',
    display_name_input: '',
    mobile_number_input: '',
    profile_picture_input: '',
    gender_input: '',
    gender_placeholder_input: '',
    language_input: '',
    language_placeholder_input: '',
    birthday_input: '',
    birthday_input_placeholder: '',
    tax_identification_number_input: '',
    profile_picture_info_message: '',
    display_name_info_message: '',
    errors: {
      form_validation_invalid_field: '',
      form_validation_invalid_email: '',
      form_validation_invalid_password_minimum_characters: '',
      form_validation_invalid_password_blank_spaces: '',
      form_validation_invalid_repeat_password_mismatch: '',
      form_validation_invalid_full_name_maximum_characters: '',
      form_validation_invalid_display_name_maximum_characters: '',
      form_validation_invalid_mobile_phone_number: '',
      form_validation_not_mobile_phone_number: '',
      form_validation_invalid_tax_identification_number: '',
      form_validation_invalid_legal_documents: '',
      enter_account_error_message: '',
      invalid_invite_error_message: '',
    },
  },
  office: {
    generics: {
      cancel: '',
      save: '',
      exit: '',
      back: '',
      apply: '',
      save_pdf: '',
      save_xlsx: '',
    },
    localized_string_input: {
      fields: {
        placeholder: '',
        rules: {
          required: '',
          max_length: '',
        },
      },
    },
    users_filters: {
      title: '',
      clear_all: '',
      sections: {
        socialResponses: {title: ''},
        shifts: {title: ''},
        activeStatus: {
          title: '',
          options: {
            active: '',
            inactive: '',
          },
        },
        taskStatus: {
          title: '',
          options: {
            planned: '',
            handled: '',
            done: '',
            not_done: '',
            not_handled: '',
          },
        },
        taskGroups: {
          title: '',
        },
        patientOccurrences: {
          title: '',
        },
        generalOccurrences: {
          title: '',
        },
      },
    },
    profile_type_tabs: {
      informal_caregiver: '',
      professional_caregiver: '',
      system_administrator: '',
      partner: '',
    },
    informal_caregiver: {
      tabs: {
        activity: '',
        profile: '',
        media: '',
        reminders: '',
      },
      add_menu: {
        button: '',
        title: '',
        create_reminder: '',
        send_photo: '',
        send_video: '',
        send_invite: '',
      },
      relationship_picker: {
        caption: '',
        dialog_title: '',
      },
      caregiver_app_info_message: '',
    },
    professional_caregiver: {
      tabs: {
        statistics: '',
        digital_inclusion: '',
        seniors: '',
        applications: '',
        services: '',
        professional_caregivers: '',
        activity: '',
        devices: '',
        user_cards: '',
        licenses: '',
        entity_photos: '',
        playlists: '',
        start: '',
        planner: '',
        occurrences: '',
        settings: '',
        sioslifeAcademy: '',
        myToDos: '',
      },
      profile: {
        generic_header: {
          title: '',
          subtitle: {
            write: '',
            read: '',
          },
          breadcrumbs: {
            team: '',
            professionals: '',
            profile: '',
          },
        },
      },
      affiliation_picker: {
        caption: '',
        dialog_title: '',
      },
      settings: {
        generic_header: {
          breadcrumbs: {
            settings: '',
            institution: '',
            licenses: '',
            templates: '',
            occurrences: '',
            quick_access_devices: '',
          },
          subtitle: {
            institution: {
              write: '',
              read: '',
            },
            activities_sector: '',
            licenses: '',
            templates: {
              write: '',
              read: '',
            },
            occurrences: '',
            quick_access_devices: '',
          },
        },
        templates: {
          empty: '',
          name: '',
          area: '',
          description: '',
          update: '',
          edit: '',
          delete: '',
          revert: '',
          duplicate: '',
          cancel: '',
          delete_title: '',
          delete_subtitle: '',
          snackbar: {
            delete_success_message: '',
            delete_error_message: '',
            duplicate_success_message: '',
            duplicate_error_message: '',
            edit_name_success_message: '',
            edit_name_error_message: '',
          },
          edit_name: '',
          alert: '',
          no_permissions: '',
        },
        occurrences: {
          patients: '',
          general: '',
          general_plural: '',
          occurrence: '',
          active: '',
          action_required: '',
          notify: '',
          all_profiles: '',
          add: '',
          add_modal_title: '',
          add_modal_name: '',
          add_name_error: '',
          delete_modal_title: '',
          revert_modal_title: '',
          delete_modal_subtitle: '',
          revert_modal_subtitle: '',
          name_error: '',
          add_error_toast: '',
          add_success_toast: '',
          edit_error_toast: '',
          edit_success_toast: '',
          delete_error_toast: '',
          delete_success_toast: '',
          revert_success_toast: '',
          delete_default: '',
          edit_name_default: '',
          default: '',
          empty_general: '',
          empty_patients: '',
          no_permissions: '',
        },
        quick_access: {
          empty: '',
          name: '',
          type: '',
          access: '',
          professional: '',
          deactivate: '',
          activate_device: '',
          activate_disabled: '',
          activate_disabled_ist: '',
          no_permissions: '',
          activate_modal: {
            title: '',
            device_name: '',
            device_type: '',
            success_message: '',
            error_message: '',
            name_repeat_error: '',
          },
          edit_modal: {
            title: '',
            success_message: '',
            error_message: '',
          },
          deactivate_modal: {
            title: '',
            subtitle: '',
            success_message: '',
            error_message: '',
            button: '',
            no_name: '',
          },
        },
      },
      seniors: {
        edit: {
          profile: {
            generic_header: {
              subtitle: {
                write: '',
              },
            },
          },
        },
        table_view_screen: {
          name: '',
          social_response: '',
          age: '',
          room: '',
          status: '',
          role: '',
          phone: '',
          email: '',
        },
      },
      shifts_allocations: {
        generic_header: {
          breadcrumbs: {
            team: '',
            shifts_allocations: '',
          },
        },
        exit_edit_mode: '',
        table: {
          collaborators: '',
          today: '',
          select_shift: '',
        },
      },
      roles_and_permissions: {
        generic_header: {
          breadcrumbs: {
            team: '',
            roles_and_permissions: '',
          },
          subtitle: '',
        },
        create: '',
        edit: '',
        delete: '',
        default_role: '',
        confirm_delete: {
          title: '',
          copy: {
            title: '',
            subtitle: '',
          },
          snackbar: {
            error_message: '',
          },
        },
      },
      occurrences: {
        empty_title: '',
        empty_subtitle: '',
        table_header_date: '',
        table_header_time: '',
        table_header_type: '',
        table_header_patient: '',
        table_header_responsible: '',
        table_header_registered: '',
        table_header_status: '',
        table_header_knowledge: '',
        add_occurrence: '',
        type_placeholder: '',
        local_placeholder: '',
        patient_placeholder: '',
        responsible_placeholder: '',
        details_placeholder: '',
        status: {
          registered: '',
          not_handled: '',
          handled: '',
        },
        details: '',
        information: '',
        date_hour: '',
        acknowledge: '',
        add_notes: '',
        write_notes: '',
        acknowledge_success: '',
        acknowledge_error: '',
        handle_success: '',
        handle_error: '',
        responsible: '',
        registered_by: '',
        took_acknowledge: '',
        history: {
          acknowledge: '',
          state_update: '',
        },
        notes_success: '',
        notes_error: '',
      },
    },
    system_administrator: {
      tabs: {
        statistics: '',
        activity: '',
        devices: '',
        apiDocs: '',
        applications: '',
        entities: '',
        cards: '',
        licenses: '',
        seniors: '',
        caregivers: '',
        playlists: '',
        gdprErasureRequests: '',
      },
    },
    partner: {
      tabs: {
        home: '',
        apiDocs: '',
      },
    },
    legacy_integration: {
      entity_services_disabled_alert_title: '',
      entity_services_disabled_alert_message: '',
    },
    none: {
      tabs: {
        home: '',
      },
    },
    permissions: {
      access_denied_message: '',
    },
    access: {
      denied_message_first: '',
      denied_message_second: '',
      care_management: '',
      digital_inclusion: '',
      speak: '',
      tooltip: '',
    },
    pending_tasks: {
      alert: '',
      see_tasks: '',
      header_title: '',
      info: '',
      empty: '',
      all: '',
      validate: '',
      modal_title: '',
      modal_observation: '',
      modal_validate: '',
      snackbar_success: '',
      snackbar_error: '',
      modal_task_validation_title: '',
    },
  },
  seniors: {
    root: {
      title: '',
      add_button: '',
      search_input_placeholder: '',
      name_header: '',
      gender_header: '',
      state_header: '',
      state_value_true: '',
      state_value_false: '',
      no_seniors: '',
      deleted_senior_dialog_title: '',
      deleted_senior_dialog_message: '',
      deleted_senior_dialog_ok_button: '',
      senior: '',
      seniors: '',
      modals: {
        add_senior_flow: {
          form: {
            title: '',
            cancel: '',
            add: '',
            inputs: {
              active: '',
              name: {
                label: '',
                placeholder: '',
                required_message: '',
                pattern_message: '',
                max_message: '',
              },
              name_alias: {
                label: '',
                placeholder: '',
                required_message: '',
                pattern_message: '',
                max_message: '',
              },
              birthdate: {
                label: '',
                placeholder: '',
                required_message: '',
              },
            },
          },
          confirm: {
            title: '',
            confirm_title: '',
            confirm_subtitle: '',
            cancel: '',
            add: '',
          },
          snackbar: {
            success_message: '',
            error_message: '',
          },
        },
      },
    },
    edit: {
      senior_dcm: {
        careplan: {
          load_error: '',
          caregiver: {
            title: '',
            unnasigned: '',
            unnasigned_tooltip: '',
          },
          activities: {
            add_button: '',
            load_error: '',
            empty_state: {
              title: '',
              subtitle: '',
            },
          },
          on_save: {
            snackbar: {
              success_message: '',
              error_message: '',
            },
          },
          on_update: {
            snackbar: {
              success_message: '',
              error_message: '',
            },
          },
          on_delete: {
            title: '',
            description: '',
            snackbar: {
              success_message: '',
              error_message: '',
            },
          },
        },
        individual_plan: {
          add_cares: '',
          caregiver: {
            title: '',
            coordinator: '',
            unassigned: '',
            unassigned_tooltip: '',
          },
          observations: '',
          created_at: '',
          valid_until: '',
          not_defined: '',
          empty_state: {
            title: '',
            subtitle: '',
          },
          new_diagnostic: '',
          diagnostic: '',
          goal: '',
          new_goal: '',
          new_objective: '',
          history: {
            action: '',
            title: '',
            close: '',
            version: '',
            unknown_author: '',
            load_error: '',
            source: {
              manual: '',
              ai: '',
              restore: '',
            },
            summary: {
              entity: {
                plan: '',
                diagnostic: '',
                goal: '',
                objective: '',
              },
              entity_plural: {
                plan: '',
                diagnostic: '',
                goal: '',
                objective: '',
              },
              field: {
                definition: '',
                responsibleUserId: '',
                cares: '',
                activityTypesIds: '',
                indicators: '',
                isActive: '',
                coordinatorUserId: '',
                validUntil: '',
                observations: '',
                diagnosticsOrder: '',
              },
              created: '',
              created_unnamed: '',
              created_many: '',
              deleted: '',
              deleted_unnamed: '',
              deleted_many: '',
              updated: '',
              updated_many: '',
              more: '',
              restored_from: '',
            },
            restore: {
              button: '',
              prompt_title: '',
              prompt_description: '',
              confirm: '',
              success: '',
              conflict: '',
              error: '',
            },
            view_version: '',
            back: '',
            detail_load_error: '',
            no_diagnostics: '',
            detail_note: '',
            change_type_unknown: '',
            change_type: {
              baseline: '',
              'plan-created': '',
              'plan-updated': '',
              'plan-archived': '',
              'plan-reactivated': '',
              'diagnostic-created': '',
              'diagnostic-updated': '',
              'diagnostic-deleted': '',
              'goal-created': '',
              'goal-updated': '',
              'goal-deleted': '',
              'objective-created': '',
              'objective-updated': '',
              'objective-deleted': '',
              'bulk-append': '',
              'bulk-replace': '',
              restored: '',
            },
          },
          ai_generate: {
            title: '',
            description: '',
            focus_label: '',
            focus_placeholder: '',
            automatic: '',
            with_focus: '',
          },
          ai_proposal: {
            title: '',
            subtitle: '',
            discard: '',
            approve: '',
            approved: '',
            replaced: '',
            apply_prompt: {
              title: '',
              description: '',
              replace: '',
              append: '',
            },
            rate_limited: '',
            save_error: '',
            invalid_references: '',
            error: '',
          },
          on_delete: {
            title: '',
            description: '',
            snackbar: {
              success_message: '',
              error_message: '',
            },
          },
          add_diagnostic: {
            title: '',
            edit: '',
            form: {
              definition: {
                label: '',
                placeholder: '',
                error_message: '',
              },
            },
          },
          on_diagnostic_remove: {
            header: '',
            title: '',
            description: '',
          },
          add_diagnostic_goal: {
            title: '',
            edit: '',
            form: {
              definition: {
                label: '',
                placeholder: '',
                error_message: '',
              },
              responsibleUser: {
                label: '',
                placeholder: '',
              },
            },
          },
          on_diagnostic_goal_remove: {
            header: '',
            title: '',
            description: '',
          },
          add_diagnostic_goal_objective: {
            title: '',
            edit: '',
            form: {
              definition: {
                label: '',
                placeholder: '',
                error_message: '',
              },
            },
            cares: {
              add_non_automatic: '',
              non_automatic_title: '',
              max_reached: '',
              too_long: '',
            },
            snackbar: {
              error: '',
              invalid_references: '',
            },
            table: {
              definition: '',
              cares: '',
              indicators: '',
              targets: '',
              execution: '',
            },
          },
          on_diagnostic_goal_objective_remove: {
            header: '',
            title: '',
            description: '',
          },
        },
      },
    },
  },
  senior_tabs: {
    tabs: {
      profile: '',
      caregivers: '',
      applications: '',
      devices: '',
      activity: '',
      statistics: '',
      user_cards: '',
      health: '',
      affiliations: '',
      playlists: '',
      external_accounts: '',
    },
    errors: {
      senior_does_not_exist_error: '',
    },
  },
  health_profile_form: {
    clinical_conditions_title: '',
    visual_difficulty_label: '',
    hearing_difficulty_label: '',
    cognitive_deficit_label: '',
    parkinson_label: '',
    alzheimer_label: '',
    other_dementias_label: '',
    reduced_mobility_upper_limbs_label: '',
    reduced_mobility_lower_limbs_label: '',
    paralysis_left_limb_label: '',
    paralysis_right_limb_label: '',
    wheelchair_label: '',
    illiterate_label: '',
    disable_clinical_conditions_tooltip: '',
    errors: {
      update_health_profile_error_message: '',
    },
    noHealthMeasurements: '',
  },
  health_charts: {
    noData: '',
    heartRate: {
      subtitle1: '',
    },
    bloodOxygen: {
      subtitle1: '',
      subtitle2: '',
    },
    bloodPressure: {
      subtitle1: '',
      subtitle2: '',
    },
    bloodGlucose: {
      subtitle1: '',
      subtitle2: '',
    },
    bodyTemperature: {
      subtitle1: '',
    },
    bodyWeight: {
      subtitle1: undefined,
    },
    errors: {
      fetch: '',
    },
  },
  health_measurements: {
    title: '',
    units: {
      beatsPerMinute: '',
      breathsPerMinute: '',
    },
  },
  senior_caregivers_listing: {
    invite_caregiver_button: '',
    invites_history_button: '',
    no_caregivers: '',
    name_header: '',
    relationship_type_header: '',
    remove_relationship_header: '',
    remove_relationship_dialog_title: '',
    remove_relationship_dialog_message: '',
    remove_relationship_button: '',
    remove_relationship_button_tooltip: '',
    remove_relationship_error_message: '',
    remove_relationship_success_message: '',
  },
  senior_relationships_invites_history: {
    title: '',
    no_invites: '',
    invite_caregiver_button: '',
    cancel_button: '',
    process_closed: '',
    name_header: '',
    contact_header: '',
    state_header: '',
    status_header: '',
    cancel_invite_dialog_title: '',
    cancel_invite_dialog_message: '',
    cancel_invite_dialog_action_yes_button: '',
    cancel_invite_dialog_action_no_button: '',
    cancel_invite_error_message: '',
    cancel_invite_success_message: '',
  },
  informal_caregiver_invite_form: {
    title: '',
    name_input: '',
    contact_method_input: '',
    email_input: '',
    mobile_phone_number_input: '',
    save_button: '',
    saving_button: '',
    save_dialog_title: '',
    save_dialog_message: '',
    save_dialog_action_save_button: '',
    router_prompt_title: '',
    router_prompt_message: '',
    cancel_toast: '',
    success_message: '',
    errors: {
      form_validation_invalid_field: '',
      form_validation_invalid_mobile_phone_number: '',
      form_validation_not_mobile_phone_number: '',
      form_validation_invalid_email: '',
      error_message: '',
    },
  },
  devices_associations: {
    identifier_header: '',
    type_header: '',
    state_header: '',
    state_value_true: '',
    state_value_false: '',
    remove_device_header: '',
    no_devices: '',
    associate_device_button: '',
    remove_device_dialog_title: '',
    remove_device_dialog_message: '',
    remove_device_button: '',
    remove_device_button_disabled_tooltip: '',
    remove_device_error_message: '',
    remove_device_success_message: '',
  },
  user_cards_associations: {
    name_header: '',
    state_header: '',
    state_value_true: '',
    state_value_false: '',
    remove_card_header: '',
    associate_card_button: '',
    no_cards: '',
    remove_card_dialog_title: '',
    remove_card_dialog_message: '',
    remove_card_button: '',
    remove_card_button_disabled_tooltip: '',
    remove_card_error_message: '',
    remove_card_success_message: '',
  },
  associate_user_card_form: {
    title: '',
    card_name_input: '',
    entity_input: '',
    card_name_info_message: '',
    save_button: '',
    saving_button: '',
    save_dialog_title: '',
    save_dialog_message: '',
    save_dialog_action_cancel_button: '',
    save_dialog_action_save_button: '',
    router_prompt_title: '',
    router_prompt_message: '',
    router_prompt_action_cancel_button: '',
    router_prompt_action_ok_button: '',
    cancel_toast: '',
    no_affiliations_info_message: '',
    success: {save_success_button: '', success_message: ''},
    errors: {
      error_message: '',
      error_on_save_button: '',
      form_validation_invalid_field: '',
    },
  },
  associate_device_form: {
    title: '',
    identifier_input: '',
    entity_input: '',
    save_button: '',
    saving_button: '',
    save_dialog_title: '',
    save_dialog_message: '',
    save_dialog_action_cancel_button: '',
    save_dialog_action_save_button: '',
    router_prompt_title: '',
    router_prompt_message: '',
    cancel_toast: '',
    no_affiliations_info_message: '',
    success: {save_success_button: '', success_message: ''},
    errors: {
      error_on_save_button: '',
      form_validation_invalid_field: '',
      error_message: '',
    },
  },
  external_accounts: {
    types: {
      call: '',
      partner_p3_n1: '',
      partner_p3_n2: '',
      partner_p3_n3: '',
      partner_p3_n4: '',
    },
    list: {
      type_header: '',
      delete_account_header: '',
      delete_account_button: '',
      associate_account_button: '',
      no_accounts: '',
      error_message: '',
      delete_account_dialog_title: '',
      delete_account_dialog_description: '',
      delete_account_dialog_cannot_be_undone: '',
      delete_account_dialog_confirm_button: '',
      delete_account_dialog_cancel_button: '',
      delete_account_success_message: '',
      delete_account_error_message: '',
    },
    associate: {
      title: '',
      type_input: '',
      save_button: '',
      saving_button: '',
      save_dialog_title: '',
      save_dialog_message: '',
      save_dialog_action_cancel_button: '',
      save_dialog_action_save_button: '',
      no_available_types_message: '',
      success_message: '',
      errors: {
        generic_message: '',
        conflict_message: '',
        provider_error_message: '',
        error_on_save_button: '',
      },
    },
    details: {
      delete_button: '',
      fields: {
        password: '',
        application_name: '',
        username: '',
        language: '',
        project_identification: '',
        serial: '',
        profile: '',
        timezone: '',
        institution_id: '',
        instance_name: '',
        manufacturer: '',
        model: '',
        user_id: '',
        patient_id: '',
        email: '',
      },
      errors: {
        not_found_message: '',
      },
    },
  },
  caregivers: {
    root: {
      title: '',
      search_input_placeholder: '',
      name_header: '',
      email_header: '',
      state_header: '',
      state_value_true: '',
      state_value_false: '',
      no_caregivers: '',
    },
  },
  professional_caregivers: {
    root: {
      title: '',
      invite_button: '',
      search_input_placeholder: '',
      name_header: '',
      email_header: '',
      affiliation_type_header: '',
      state_header: '',
      state_value_true: '',
      state_value_false: '',
      no_professional_caregivers: '',
      deleted_professional_caregiver_dialog_title: '',
      deleted_professional_caregiver_dialog_message: '',
      deleted_professional_caregiver_dialog_ok_button: '',
      colaborator: '',
      colaborators: '',
      modals: {
        add_staff_flow: {
          form: {
            title: '',
            cancel: '',
            send_invite: '',
            create_profile: '',
            inputs: {
              name: {
                label: '',
                placeholder: '',
                required_message: '',
                pattern_message: '',
                max_message: '',
              },
              email: {
                label: '',
                placeholder: '',
                pattern_message: '',
                required_message: '',
              },
              roles: {
                label: '',
                placeholder: '',
              },
              invitation_type: {
                label: '',
                placeholder: '',
                required_message: '',
                via_email: '',
                via_sms: '',
                via_quickAccessCode: '',
              },
              phone_number: {
                label: '',
                placeholder: '',
                required_message: '',
                is_valid_message: '',
              },
              quick_access_code: {
                label: '',
                placeholder: '',
                required_message: '',
                is_valid_message: '',
              },
            },
          },
          confirm: {
            title: '',
            title_quickAccessCode: '',
            confirm_title: '',
            confirm_title_quickAccessCode: '',
            confirm_subtitle: '',
            cancel: '',
            send_invite: '',
            create_profile: '',
          },
          success: {
            title: '',
            title_quickAccessCode: '',
            confirm_title: '',
            confirm_title_quickAccessCode: '',
            confirm_subtitle: '',
            confirm_subtitle_quickAccessCode: '',
            confirm: '',
          },
          snackbar: {
            success_message: '',
            error_message: '',
            success_message_create_profile: '',
            error_message_create_profile: '',
          },
        },
      },
    },
  },
  caregiver_tabs: {
    tabs: {
      profile: '',
      affiliations: '',
      applications: '',
      user_cards: '',
      playlists: '',
    },
    errors: {
      caregiver_does_not_exist_error: '',
    },
  },
  user_affiliations: {
    entity_name_header: '',
    entity_type_header: '',
    affiliation_type_header: '',
    remove_affiliation_header: '',
    remove_affiliation_button: '',
    remove_affiliation_dialog_title: '',
    remove_affiliation_dialog_message: '',
    remove_affiliation_dialog_action_yes_button: '',
    remove_affiliation_dialog_action_no_button: '',
    update_affiliation_dialog_title: '',
    update_affiliation_dialog_message: '',
    update_affiliation_dialog_action_yes_button: '',
    update_affiliation_dialog_action_no_button: '',
    no_affiliations: '',
    errors: {
      remove_affiliation_error_message: '',
      update_affiliation_error_message: '',
    },
  },
  user_applications: {
    entity_filter: '',
    search_input_placeholder: '',
    name_header: '',
    category_header: '',
    state_header: '',
    state_value_true: '',
    state_value_false: '',
    disabled_state_tooltip: '',
    no_applications: '',
    enable_application_dialog_title: '',
    enable_application_dialog_message: '',
    enable_application_for_entity_dialog_message: '',
    enable_application_dialog_action_yes_button: '',
    enable_application_dialog_action_no_button: '',
    disable_application_dialog_title: '',
    disable_application_dialog_message: '',
    disable_application_for_entity_dialog_message: '',
    disable_application_dialog_action_yes_button: '',
    disable_application_dialog_action_no_button: '',
    no_affiliations_info_message: '',
    errors: {
      enable_application_error_message: '',
      disable_application_error_message: '',
      update_state_application_error_message: '',
    },
  },
  user_form: {
    title_create_senior: '',
    title_current_user_profile: '',
    delete_button: '',
    delete_caregiver_dialog_title: '',
    delete_caregiver_dialog_content: '',
    delete_senior_dialog_title: '',
    delete_senior_dialog_content: '',
    delete_caregiver_invite_title: '',
    delete_caregiver_invite_content: '',
    entity_input: '',
    full_name_input: '',
    display_name_input: '',
    state_input: '',
    state_value_true: '',
    state_value_false: '',
    gender_input: '',
    gender_placeholder_input: '',
    birthday_input: '',
    date_placeholder_input: '',
    admission_date_input: '',
    departure_date_input: '',
    address_input: '',
    address_placeholder_input: '',
    religion_input: '',
    religion_placeholder_input: '',
    profession_input: '',
    profession_description_input: '',
    social_network_city_input: '',
    language_input: '',
    language_placeholder_input: '',
    region_input: '',
    region_placeholder_input: '',
    input_disabled_by_unknown_region: '',
    email_input: '',
    email_placeholder_input: '',
    mobile_phone_number_input: '',
    mobile_phone_number_placeholder_input: '',
    mobile_and_landline_phone_number_input: '',
    tax_payer_number_input: '',
    tax_payer_number_input_placeholder: '',
    patient_number_input: '',
    patient_number_input_placeholder: '',
    social_security_number_input: '',
    social_security_number_input_placeholder: '',
    room_input: '',
    room_placeholder_input: '',
    social_responses_input: '',
    social_responses_placeholder_input: '',
    profile_picture_input: '',
    process_number_input: '',
    process_number_input_placeholder: '',
    recurring_fee_input: '',
    recurring_fee_input_placeholder: '',
    marital_status_input: '',
    marital_status_input_placeholder: '',
    aditional_info_input: '',
    additional_info_input_placeholder: '',
    education_level_input: '',
    education_level_input_placeholder: '',
    citizen_card_input: '',
    citizen_card_input_placeholder: '',
    cancel_button: '',
    save_button: '',
    saving_button: '',
    deleting_button: '',
    create_senior_dialog_title: '',
    create_senior_dialog_message: '',
    edit_senior_dialog_title: '',
    edit_senior_dialog_message: '',
    edit_caregiver_dialog_title: '',
    edit_caregiver_dialog_message: '',
    edit_caregiver_affiliation_type_dialog_title: '',
    edit_caregiver_affiliation_type_dialog_message: '',
    edit_current_user_profile_dialog_title: '',
    edit_current_user_profile_dialog_message: '',
    save_dialog_action_cancel_button: '',
    save_dialog_action_save_button: '',
    senior_router_prompt_edit_title: '',
    senior_router_prompt_create_title: '',
    senior_router_prompt_create_message: '',
    senior_router_prompt_edit_message: '',
    caregiver_edit_router_prompt_edit_title: '',
    caregiver_edit_router_prompt_edit_message: '',
    caregiver_edit_affiliation_type_router_prompt_edit_title: '',
    caregiver_edit_affiliation_type_router_prompt_edit_message: '',
    current_user_router_prompt_edit_title: '',
    current_user_router_prompt_edit_message: '',
    router_prompt_action_cancel_button: '',
    router_prompt_action_ok_button: '',
    senior_create_cancel_toast: '',
    senior_edit_cancel_toast: '',
    caregiver_edit_cancel_toast: '',
    current_user_edit_cancel_toast: '',
    caregiver_edit_affiliation_type_cancel_toast: '',
    current_user_edit_email_not_allowed_tooltip_title: '',
    caregiver_edit_email_not_allowed_tooltip_title: '',
    current_user_edit_state_not_allowed_tooltip_title: '',
    profile_picture_info_message: '',
    display_name_other_user_info_message: '',
    display_name_current_user_info_message: '',
    roles_ids_input: '',
    roles_ids_placeholder_input: '',
    input_placeholder: '',
    not_specified: '',
    input_read_only_tooltip: '',
    quick_access_code_input: '',
    quick_access_code_redefine_button: '',
    quick_access_code_disabled: '',
    success: {
      save_success_button: '',
      delete_success_button: '',
      create_senior_success_message: '',
      edit_senior_success_message: '',
      edit_caregiver_success_message: '',
      edit_caregiver_roles_ids_success_message: '',
      edit_current_user_success_message: '',
      edit_current_user_app_language_to_chosen_language_success_message: '',
      edit_current_user_app_language_to_browser_language_success_message: '',
      edit_current_user_app_language_to_default_language_success_message: '',
      success_delete_senior: '',
      success_delete_caregiver: '',
      success_delete_invite: '',
    },
    errors: {
      error_on_save_button: '',
      error_on_delete_senior_button: '',
      error_on_delete_caregiver_button: '',
      error_on_delete_invite: '',
      edit_form_validation_invalid_field: '',
      caregiver_edit_affiliation_type_form_validation_invalid_field: '',
      form_validation_invalid_phone_number: '',
      form_validation_not_mobile_phone_number: '',
      form_validation_invalid_email: '',
      form_validation_invalid_number: '',
      form_validation_invalid_room_name: '',
      form_validation_room_maximum_characters: '',
      form_validation_invalid_display_name_maximum_characters: '',
      create_active_senior_licenses_number_exceeded_error: '',
      activate_senior_licenses_number_exceeded_error: '',
      form_validation_invalid_quick_access_code: '',
      form_validation_process_number_max_chars: '',
      form_validation_recurring_fee_max_chars: '',
      form_validation_aditional_info_max_chars: '',
    },
  },
  user_attachments: {
    list: {
      headers: {
        name: '',
        description: '',
        author: '',
        date: '',
        size: '',
      },
      actions: {
        edit: '',
        delete: '',
        download: '',
      },
    },
    empty: {
      title: '',
      subtitle: '',
    },
    modals: {
      create: {
        title: '',
      },
      edit: {
        title: '',
        name: '',
        description: '',
        errors: {
          name_required: '',
          name_max_length: '',
          description_max_length: '',
        },
      },
      delete: {
        title: '',
        description: '',
      },
    },

    success: {
      create: '',
      edit: '',
      delete: '',
    },
    error: {
      create: '',
      edit: '',
      delete: '',
      download: '',
    },
    access_denied: {
      create: '',
      edit: '',
      delete: '',
    },
  },
  entity_services: {
    root: {
      title: '',
      add_button: '',
      search_input_placeholder: '',
      name_header: '',
      display_order_header: '',
      state_header: '',
      state_value_true: '',
      state_value_false: '',
      no_services: '',
      deleted_service_dialog_title: '',
      deleted_service_dialog_message1: '',
      deleted_service_dialog_message2: '',
      deleted_service_dialog_ok_button: '',
    },
    edit: {
      title_create: ' ',
      title_edit: '',
      title_view: '',
      exit_button: '',
      save_button: '',
      saving_button: '',
      title_input: '',
      state_input: '',
      phone_number_input: '',
      phone_number_use_general_number: '',
      phone_number_use_specific_number: '',
      display_order_input: '',
      description_input: '',
      details_input: '',
      attach_document_input: '',
      document_informative_note_input: '',
      icon_input: '',
      image_input: '',
      button_preview: '',
      state_value_true: '',
      state_value_false: '',
      number_input: '',
      upload: '',
      remove_document: '',
      view_document: '',
      image_info: '',
      delete_button: '',
      deleting_button: '',
      delete_dialog_title: '',
      delete_dialog_content: '',
      delete_dialog_action_yes_button: '',
      delete_dialog_action_no_button: '',
      router_prompt_edit_title: '',
      router_prompt_create_title: '',
      router_prompt_create_message: '',
      router_prompt_edit_message: '',
      router_prompt_action_cancel_button: '',
      router_prompt_action_ok_button: '',
      create_service_dialog_title: '',
      create_service_dialog_message: '',
      edit_service_dialog_title: '',
      edit_service_dialog_message: '',
      save_service_dialog_action_cancel_button: '',
      save_service_dialog_action_save_button: '',
      service_create_cancel_toast: '',
      service_edit_cancel_toast: '',
      errors: {
        error_on_save_button: '',
        error_on_delete_button: '',
        edit_form_validation_invalid_field: '',
        create_form_validation_invalid_field: '',
        create_form_validation_invalid_icon: '',
        create_form_validation_invalid_image: '',
        form_validation_invalid_phone_number: '',
        service_does_not_exist_error: '',
      },
      success: {
        save_success_button: '',
        delete_success_button: '',
        create_success_message: '',
        edit_success_message: '',
      },
    },
  },
  applications: {
    system_administrator: {
      root: {
        title: '',
        search_input_placeholder: '',
        name_header: '',
        category_header: '',
        state_header: '',
        state_value_true: '',
        state_value_false: '',
        no_applications: '',
        add_button: '',
      },
      edit: {
        entities: {
          search_input_placeholder: '',
          name_header: '',
          type_header: '',
          state_header: '',
          state_value_true: '',
          state_value_false: '',
          no_entities: '',
          enable_application_dialog_message: '',
          enable_application_dialog_action_yes_button: '',
          enable_application_dialog_action_no_button: '',
          disable_application_dialog_message: '',
          disable_application_dialog_action_yes_button: '',
          disable_application_dialog_action_no_button: '',
          errors: {
            enable_application_error_message: '',
            disable_application_error_message: '',
            update_state_application_error_message: '',
          },
        },
      },
    },
    professional_caregiver: {
      root: {
        search_input_placeholder: '',
        name_header: '',
        category_header: '',
        state_header: '',
        state_value_true: '',
        state_value_false: '',
        no_applications: '',
        enable_application_dialog_message: '',
        enable_application_dialog_action_yes_button: '',
        enable_application_dialog_action_no_button: '',
        disable_application_dialog_message: '',
        disable_application_dialog_action_yes_button: '',
        disable_application_dialog_action_no_button: '',
        errors: {
          enable_application_error_message: '',
          disable_application_error_message: '',
          update_state_application_error_message: '',
        },
      },
      edit: {
        users: {
          search_input_placeholder: '',
          name_header: '',
          type_header: '',
          state_header: '',
          state_value_true: '',
          state_value_false: '',
          no_users: '',
          enable_application_dialog_message: '',
          enable_application_dialog_action_yes_button: '',
          enable_application_dialog_action_no_button: '',
          disable_application_dialog_message: '',
          disable_application_dialog_action_yes_button: '',
          disable_application_dialog_action_no_button: '',
          errors: {
            enable_application_error_message: '',
            disable_application_error_message: '',
            update_state_application_error_message: '',
          },
        },
      },
    },
  },
  application_tabs: {
    tabs: {
      details: '',
      entities: '',
      users: '',
    },
    errors: {application_does_not_exist_error: ''},
  },
  application_form: {
    name_input: '',
    state_input: '',
    state_value_true: '',
    state_value_false: '',
    description_input: '',
    is_system_application_input: '',
    is_system_application_value_yes: '',
    is_system_application_value_no: '',
    available_for_user_types_input: '',
    icon_input: '',
    picture_input: '',
    category_input: '',
    activity_type_input: '',
    windows_key_input: '',
    android_key_input: '',
    input_disabled_tooltip: '',
  },
  devices: {
    root: {
      search_input_placeholder: '',
      identifier_header: '',
      type_header: '',
      state_header: '',
      state_value_true: '',
      state_value_false: '',
      user_header: '',
      no_devices: '',
      add_button: '',
    },
  },
  device_tabs: {
    device_title: '',
    tabs: {
      details: '',
      health: '',
      information: '',
    },
    errors: {device_does_not_exist_error: ''},
  },
  user_cards: {
    root: {
      title: '',
      search_input_placeholder: '',
      name_header: '',
      state_header: '',
      state_value_true: '',
      state_value_false: '',
      user_header: '',
      no_cards: '',
      add_button: '',
      deleted_card_dialog_title: '',
      deleted_card_dialog_message: '',
      deleted_card_dialog_ok_button: '',
    },
    edit: {errors: {card_does_not_exist_error: ''}},
  },
  gdpr_erasure_requests: {
    root: {
      title: '',
      add_button: '',
      no_requests: '',
      status_header: '',
      requested_at_header: '',
      completed_at_header: '',
      error_header: '',
      user_id_hash_header: '',
      user_email_hash_header: '',
      status_processing: '',
      status_completed: '',
      status_failed: '',
    },
    create_modal: {
      title: '',
      email_label: '',
      email_placeholder: '',
      email_required: '',
      email_invalid: '',
      cancel_button: '',
      submit_button: '',
      submitting_button: '',
      confirm_title: '',
      confirm_description: '',
      confirm_cannot_be_undone: '',
      confirm_button: '',
      cancel_confirm_button: '',
    },
    errors: {
      forbidden: '',
      user_not_found: '',
      unknown: '',
    },
    success: {
      request_created: '',
    },
  },
  entity_photos: {
    root: {
      add_button: '',
      deleted_photo_dialog_title: '',
      deleted_photo_dialog_message: '',
      deleted_photo_dialog_ok_button: '',
      entity_photos_only_for_computer_info_message: '',
    },
    edit: {
      title_create: '',
      title_edit: '',
      photo_input: '',
      photos_input: '',
      description_input: '',
      exit_button: '',
      save_button: '',
      saving_button: '',
      photos_create_cancel_toast: '',
      photo_edit_cancel_toast: '',
      delete_button: '',
      deleting_button: '',
      delete_dialog_title: '',
      delete_dialog_content: '',
      delete_dialog_action_yes_button: '',
      delete_dialog_action_no_button: '',
      router_prompt_edit_title: '',
      router_prompt_edit_message: '',
      router_prompt_create_title: '',
      router_prompt_create_message: '',
      router_prompt_action_cancel_button: '',
      router_prompt_action_ok_button: '',
      photos_info: '',
      choose_photos_button: '',
      input_disabled_tooltip: '',
      errors: {
        error_on_save_button: '',
        error_on_delete_button: '',
        photo_does_not_exist_error: '',
        create_form_validation_invalid_field: '',
        form_validation_invalid_description_maximum_characters: '',
      },
      success: {
        save_success_button: '',
        delete_success_button: '',
        create_success_message: '',
        edit_success_message: '',
      },
      warnings: {
        partial_create_success_message: '',
      },
    },
  },
  entities: {
    root: {
      title: '',
      search_input_placeholder: '',
      name_header: '',
      type_header: '',
      state_header: '',
      state_value_true: '',
      state_value_false: '',
      no_entities: '',
      add_button: '',
      deleted_entity_dialog_title: '',
      deleted_entity_dialog_message: '',
      deleted_entity_dialog_ok_button: '',
    },
    edit: {
      tabs: {
        details: '',
        seniors: '',
        professional_caregivers: '',
        applications: '',
        devices: '',
        user_cards: '',
        activity: '',
        statistics: '',
        licenses: '',
        playlists: '',
      },
      seniors: {
        search_input_placeholder: '',
        name_header: '',
        gender_header: '',
        state_header: '',
        state_value_true: '',
        state_value_false: '',
        no_seniors: '',
        enable_senior_dialog_title: '',
        enable_senior_dialog_message: '',
        enable_senior_dialog_action_yes_button: '',
        enable_senior_dialog_action_no_button: '',
        disable_senior_dialog_title: '',
        disable_senior_dialog_message: '',
        disable_senior_dialog_action_yes_button: '',
        disable_senior_dialog_action_no_button: '',
        errors: {
          enable_senior_error_message: '',
          disable_senior_error_message: '',
          update_state_senior_error_message: '',
        },
      },
      professional_caregivers: {
        search_input_placeholder: '',
        invite_button: '',
        name_header: '',
        email_header: '',
        affiliation_type_header: '',
        state_header: '',
        state_value_true: '',
        state_value_false: '',
        no_professional_caregivers: '',
      },
      applications: {
        search_input_placeholder: '',
        name_header: '',
        category_header: '',
        state_header: '',
        state_value_true: '',
        state_value_false: '',
        no_applications: '',
        enable_application_dialog_message: '',
        enable_application_dialog_action_yes_button: '',
        enable_application_dialog_action_no_button: '',
        disable_application_dialog_message: '',
        disable_application_dialog_action_yes_button: '',
        disable_application_dialog_action_no_button: '',
        errors: {
          enable_application_error_message: '',
          disable_application_error_message: '',
          update_state_application_error_message: '',
        },
      },
      devices: {
        search_input_placeholder: '',
        identifier_header: '',
        type_header: '',
        state_header: '',
        state_value_true: '',
        state_value_false: '',
        user_header: '',
        no_devices: '',
      },
      user_cards: {
        search_input_placeholder: '',
        name_header: '',
        state_header: '',
        state_value_true: '',
        state_value_false: '',
        user_header: '',
        no_cards: '',
        front_card_design_button: '',
        back_card_design_button: '',
      },
      playlists: {
        search_input_placeholder: '',
        type_filter: '',
        name_header: '',
        state_header: '',
        state_value_true: '',
        state_value_false: '',
        no_playlist: '',
        enable_playlist_dialog_title: '',
        enable_playlist_dialog_message: '',
        enable_playlist_dialog_action_yes_button: '',
        enable_playlist_dialog_action_no_button: '',
        disable_playlist_dialog_title: '',
        disable_playlist_dialog_message: '',
        disable_playlist_dialog_action_yes_button: '',
        disable_playlist_dialog_action_no_button: '',
        errors: {
          enable_playlist_error_message: '',
          disable_playlist_error_message: '',
          update_state_playlist_error_message: '',
        },
      },
      playlist_items: {
        title: '',
        search_input_placeholder: '',
        title_header: '',
        state_header: '',
        state_value_true: '',
        state_value_false: '',
        no_items: '',
        enable_item_dialog_title: '',
        enable_item_dialog_message: '',
        enable_item_dialog_action_yes_button: '',
        enable_item_dialog_action_no_button: '',
        disable_item_dialog_title: '',
        disable_item_dialog_message: '',
        disable_item_dialog_action_yes_button: '',
        disable_item_dialog_action_no_button: '',
        errors: {
          enable_item_error_message: '',
          disable_item_error_message: '',
          update_state_item_error_message: '',
          playlist_does_not_exist_error: '',
        },
      },
      licenses: {
        number_of_monthly_active_licenses_not_defined: '',
        number_of_monthly_active_licenses_title: '',
        save_button: '',
        saving_button: '',
        edit_dialog_title: '',
        edit_dialog_content: '',
        edit_dialog_action_save_button: '',
        edit_dialog_action_cancel_button: '',
        router_prompt_title: '',
        router_prompt_message: '',
        router_prompt_action_cancel_button: '',
        router_prompt_action_ok_button: '',
        number_of_monthly_active_licenses_edit_cancel_toast: '',
        success: {save_success_button: ''},
        errors: {
          error_on_save_button: '',
          edit_form_validation_invalid_field: '',
          form_validation_invalid_number_of_monthly_active_licenses: '',
        },
      },
      errors: {entity_does_not_exist_error: ''},
    },
  },
  affiliated_entity_profile: {
    errors: {entity_does_not_exist_error: ''},
  },
  section_tabs: {exit_button: ''},
  profession_input: {no_options: '', loading: ''},
  social_network_city_input: {no_options: '', loading: ''},
  user_menu: {
    logout: '',
    profile: '',
    settings: '',
    office: '',
    dailyCareLog: '',
    errors: {logout_error_message: ''},
  },
  error_box: {
    title: '',
    description: '',
    details_button: '',
  },
  country_select: {
    title: '',
    no_options: '',
  },
  tablet_button: {
    empty_title: '',
  },
  icons_picker: {
    title: '',
    cancel_button: '',
    confirm_button: '',
  },
  image_cropper_dialog: {
    title: '',
    zoom: '',
    rotation: '',
    save_button: '',
    cancel_button: '',
  },
  loading_content: {
    loading: '',
  },
  pdf_viewer: {
    error: '',
  },
  activity_card: {
    today: '',
    yesterday: '',
    this_week: '',
    this_month: '',
    previous_month: '',
    past: '',
    entity: '',
    device: '',
    duration: '',
    end_type: '',
    participants: '',
    application: '',
    application_battle_with: '',
    level_on_app: '',
    missed_call: '',
    rejected_call: '',
    call_started: '',
    drawing_sent: '',
    drawing_saved: '',
    drawing_shared: '',
    painting_sent: '',
    painting_saved: '',
    painting_shared: '',
    and: '',
    photo_sent: '',
    photo_saved: '',
    photo_shared: '',
    camera_used: '',
    response: '',
    video_message_sent_to: '',
    video_message_sent_by: '',
    video_sent: '',
    video_saved: '',
    video_shared: '',
    currently_happening: '',
  },
  notification_card: {
    open_invite: '',
    open_occurrences: '',
    relationship_invite: {
      message_sender: '',
      message_sender_same_as_target: '',
      message_sender_unknown: '',
    },
    affiliation_invite: {
      message_sender: '',
      message_sender_same_as_target: '',
      message_sender_unknown: '',
    },
    user_signed_in: '',
    photo_sent: '',
    photo_shared: '',
    drawing_sent: '',
    drawing_shared: '',
    painting_sent: '',
    painting_shared: '',
    video_sent: '',
    video_shared: '',
    without_license: '',
    missed_call: '',
    video_message: '',
    sos_request: '',
    reminder_response: {
      message: '',
      responses: {
        positive: '',
        negative: '',
        not_responding: '',
      },
    },
    relationship_invite_request_result: {
      message_accepted: '',
      message_declined: '',
    },
    caregiver_administrator_role_request_result: {
      message_accepted: '',
      message_declined: '',
    },
    relationship_role_change: {
      message_senior_myself: '',
      message_senior_other: '',
      message_caregiver_myself: '',
      message_caregiver_other: '',
      message_unknown_myself: '',
      message_unknown_other: '',
    },
    personal_data_sharing_preferences_change: {
      message: '',
      current_data_settings_title: '',
      can_access_profile_data: '',
      can_access_contacts: '',
      can_access_applications: '',
      can_access_multimedia: '',
      can_access_reminders: '',
      can_access_activity_feed: '',
    },
    relationship_end: {
      message_myself: '',
      message_other: '',
    },
    media_processing_status: {
      video_message: {
        [ProcessStatus.Done]: '',
        [ProcessStatus.Failed]: '',
      },
      video_shared: {
        [ProcessStatus.Done]: '',
        [ProcessStatus.Failed]: '',
      },
      video_saved: {
        [ProcessStatus.Done]: '',
        [ProcessStatus.Failed]: '',
      },
      photo_shared: {
        [ProcessStatus.Done]: '',
        [ProcessStatus.Failed]: '',
      },
      photo_saved: {
        [ProcessStatus.Done]: '',
        [ProcessStatus.Failed]: '',
      },
      unknown: {
        [ProcessStatus.Done]: '',
        [ProcessStatus.Failed]: '',
      },
    },
    media_empty: '',
    new_occurrence: '',
    new_occurrence_patient: '',
    new_occurrence_assigned: '',
    new_occurrence_assigned_patient: '',
  },
  section_list: {
    refresh: '',
    no_more_data: '',
    without_data: '',
    today: '',
    old_f: '',
    old_m: '',
  },
  activity_timeline: {title: ''},
  clipboard_text_field: {
    copy_to_clipboard_button: '',
    copy_to_clipboard_tooltip_message: '',
    success: {copy_to_clipboard_success_message: ''},
  },
  activity_end_types: {
    [ActivityEndType.UserAction]: '',
    [ActivityEndType.SystemTimeout]: '',
  },
  device_types: {
    [DeviceType.Handset]: '',
    [DeviceType.Tablet]: '',
    [DeviceType.Desktop]: '',
    [DeviceType.Laptop]: '',
    [DeviceType.Unknown]: '',
  },
  camera_facing: {
    [CameraFacing.Front]: '',
    [CameraFacing.Rear]: '',
    [CameraFacing.External]: '',
    [CameraFacing.Unknown]: '',
  },
  reminder_response_values: {
    [ReminderResponseValue.Positive]: '',
    [ReminderResponseValue.Negative]: '',
    [ReminderResponseValue.NotResponding]: '',
  },
  invite_states: {
    [InviteState.Accepted]: '',
    [InviteState.Cancelled]: '',
    [InviteState.Open]: '',
    [InviteState.Pending]: '',
    [InviteState.Refused]: '',
    [InviteState.RefusedBySenior]: '',
    [InviteState.WaitingForSeniorApproval]: '',
    [InviteState.AcceptedBySenior]: '',
    [InviteState.Expired]: '',
  },
  process_statuses: {
    [ProcessStatus.Done]: '',
    [ProcessStatus.InProgress]: '',
    [ProcessStatus.ToDo]: '',
    [ProcessStatus.Undefined]: '',
    [ProcessStatus.Failed]: '',
  },
  entity_types: {
    [EntityType.DayCareCenter]: '',
    [EntityType.Family]: '',
    [EntityType.Generic]: '',
    [EntityType.HomeSupport]: '',
    [EntityType.Institution]: '',
    [EntityType.InsuranceCompany]: '',
    [EntityType.TechCompany]: '',
  },
  care_taks_not_done_reasons: {
    [CareTaskNotDoneReason.SeniorRefusal]: '',
    [CareTaskNotDoneReason.seniorAbsence]: '',
    [CareTaskNotDoneReason.LackOfMaterial]: '',
    [CareTaskNotDoneReason.SeniorWasNotFeelingWell]: '',
    [CareTaskNotDoneReason.Other]: '',
  },
  time_units: {
    seconds: '',
    minutes: '',
    hours: '',
  },
  entity_form: {
    exit_button: '',
    create_entity_title: '',
    picture_input: '',
    name_input: '',
    name_placeholder_input: '',
    state_input: '',
    state_value_true: '',
    state_value_false: '',
    description_input: '',
    type_input: '',
    language_input: '',
    language_placeholder_input: '',
    region_input: '',
    region_placeholder_input: '',
    time_zone_input: '',
    time_zone_placeholder_input: '',
    email_input: '',
    email_placeholder_input: '',
    short_name_input: '',
    short_name_placeholder_input: '',
    anniversary_input: '',
    anniversary_placeholder_input: '',
    capacity_input: '',
    capacity_placeholder_input: '',
    address_input: '',
    address_placeholder_input: '',
    website_input: '',
    website_placeholder_input: '',
    number_input: '',
    landline_phone_number_input: '',
    mobile_phone_number_input: '',
    phone_number_placeholder: '',
    services_name_input: '',
    services_name_placeholder_input: '',
    services_phone_number_input: '',
    services_image_url_input: '',
    services_image_info_message: '',
    picture_info_message: '',
    special_purpose_input: '',
    social_responses_input: '',
    social_responses_placeholder_input: '',
    special_purpose_placeholder_input: '',
    save_button: '',
    saving_button: '',
    deleting_button: '',
    delete_button: '',
    delete_dialog_title: '',
    delete_dialog_content: '',
    delete_dialog_action_yes_button: '',
    delete_dialog_action_no_button: '',
    router_prompt_create_title: '',
    router_prompt_create_message: '',
    router_prompt_edit_title: '',
    router_prompt_edit_message: '',
    router_prompt_action_cancel_button: '',
    router_prompt_action_ok_button: '',
    edit_cancel_toast: '',
    create_cancel_toast: '',
    edit_special_purpose_not_allowed_tooltip_title: '',
    edit_is_active_not_allowed_tooltip_title: '',
    input_disabled_tooltip: '',
    not_specified: '',
    alert: {
      short_name_input: '',
    },
    success: {
      save_success_button: '',
      delete_success_button: '',
      create_success_message: '',
      edit_success_message: '',
    },
    errors: {
      error_on_save_button: '',
      error_on_delete_button: '',
      edit_form_validation_invalid_field: '',
      create_form_validation_invalid_field: '',
      form_validation_invalid_full_name_maximum_characters: '',
      form_validation_invalid_landline_phone_number: '',
      form_validation_invalid_mobile_phone_number: '',
      form_validation_not_mobile_phone_number: '',
      form_validation_invalid_services_phone_number: '',
      form_validation_invalid_email: '',
      form_validation_invalid_website: '',
      form_validation_invalid_capacity: '',
      form_validation_required_social_responses: '',
    },
  },
  professional_caregiver_invite_form: {
    exit_button: '',
    title: '',
    entity_input: '',
    name_input: '',
    contact_method_input: '',
    email_input: '',
    mobile_phone_number_input: '',
    affiliation_type_input: '',
    save_dialog_title: '',
    save_dialog_message: '',
    save_dialog_action_cancel_button: '',
    save_dialog_action_save_button: '',
    router_prompt_title: '',
    router_prompt_message: '',
    router_prompt_action_cancel_button: '',
    router_prompt_action_ok_button: '',
    cancel_toast: '',
    save_button: '',
    saving_button: '',
    success: {save_success_button: '', success_message: ''},
    errors: {
      error_on_save_button: '',
      form_validation_invalid_field: '',
      form_validation_invalid_mobile_phone_number: '',
      form_validation_not_mobile_phone_number: '',
      form_validation_invalid_email: '',
    },
  },
  invite_contact_methods: {
    [InviteContactMethod.Email]: '',
    [InviteContactMethod.MobilePhoneNumber]: '',
  },
  search_select_input: {
    no_options: '',
    loading: '',
    more_button: '',
    items_showing_information: '',
  },
  user_card_form: {
    exit_button: '',
    create_user_card_title: '',
    edit_user_card_title: '',
    view_user_card_title: '',
    name_input: '',
    state_input: '',
    state_value_true: '',
    state_value_false: '',
    tag_input: '',
    entity_input: '',
    user_input: '',
    user_info_message: '',
    save_button: '',
    saving_button: '',
    deleting_button: '',
    delete_button: '',
    delete_dialog_title: '',
    delete_dialog_content: '',
    create_dialog_title: '',
    create_dialog_message: '',
    edit_dialog_title: '',
    edit_dialog_message: '',
    router_prompt_create_title: '',
    router_prompt_create_message: '',
    router_prompt_edit_title: '',
    router_prompt_edit_message: '',
    router_prompt_action_cancel_button: '',
    router_prompt_action_ok_button: '',
    edit_cancel_toast: '',
    create_cancel_toast: '',
    disabled_tooltip: '',
    success: {
      save_success_button: '',
      delete_success_button: '',
      create_success_message: '',
      edit_success_message: '',
      senior_inactive_success: '',
    },
    errors: {
      error_on_save_button: '',
      error_on_delete_button: '',
      edit_form_validation_invalid_field: '',
      create_form_validation_invalid_field: '',
      error_on_delete_user: '',
      error_on_marking_senior_as_inactive: '',
    },
  },
  device_form: {
    exit_button: '',
    save_button: '',
    saving_button: '',
    create_device_title: '',
    type_input: '',
    state_input: '',
    state_value_true: '',
    state_value_false: '',
    number_input: '',
    entity_input: '',
    user_input: '',
    language_input: '',
    language_placeholder_input: '',
    sign_in_type_input: '',
    sign_in_type_placeholder_input: '',
    mac_address_input: '',
    serial_number_input: '',
    user_info_message: '',
    edit_type_not_allowed_tooltip_title: '',
    edit_serial_number_not_allowed_tooltip_title: '',
    edit_mac_address_not_allowed_tooltip_title: '',
    edit_number_not_allowed_tooltip_title: '',
    edit_sign_in_type_not_allowed_tooltip_title: '',
    input_disabled_tooltip: '',
    deleting_button: '',
    delete_button: '',
    delete_dialog_title: '',
    delete_dialog_content: '',
    create_dialog_title: '',
    create_dialog_message: '',
    edit_dialog_title: '',
    edit_dialog_message: '',
    save_dialog_action_cancel_button: '',
    save_dialog_action_save_button: '',
    router_prompt_create_title: '',
    router_prompt_create_message: '',
    router_prompt_edit_title: '',
    router_prompt_edit_message: '',
    router_prompt_action_cancel_button: '',
    router_prompt_action_ok_button: '',
    edit_cancel_toast: '',
    create_cancel_toast: '',
    success: {
      create_message: '',
      edit_message: '',
      deleted_message: '',
    },
    errors: {
      create_message: '',
      edit_message: '',
      edit_form_validation_invalid_field: '',
      create_form_validation_invalid_field: '',
      deleted_message: '',
    },
    isInDebugMode_input: '',
    isInDebugMode_placeholder_input: '',
  },
  user_sign_in_types: {
    [UserSignInType.Card]: '',
    [UserSignInType.Quick]: '',
    [UserSignInType.Code]: '',
  },
  entity_special_purposes: {
    [EntitySpecialPurpose.Commercial]: '',
    [EntitySpecialPurpose.Demonstration]: '',
    [EntitySpecialPurpose.Research]: '',
    [EntitySpecialPurpose.Testing]: '',
  },
  entity_statistics_dashboard: {
    title: '',
    refresh_button: '',
    text_charts: {
      number_of_active_seniors_title: '',
      number_of_active_seniors_subtitle: '',
      number_of_active_professional_caregivers_title: '',
      number_of_active_professional_caregivers_subtitle: '',
      number_of_active_informal_caregivers_title: '',
      number_of_active_informal_caregivers_subtitle: '',
      number_of_pending_invites_title: '',
      number_of_pending_invites_subtitle: '',
      number_of_calls_title: '',
      number_of_calls_subtitle: '',
      number_of_outgoing_calls_title: '',
      number_of_outgoing_calls_subtitle: '',
      number_of_incoming_calls_title: '',
      number_of_incoming_calls_subtitle: '',
    },
    table_charts: {
      number_of_active_devices_title: '',
      number_of_active_digital_inclusion_devices_title: '',
      number_of_active_quick_access_devices_title: '',
      number_of_active_devices_device_type_column: '',
      number_of_active_devices_total_column: '',
      top_users_title: '',
      top_users_subtitle: '',
      top_users_user_column: '',
      top_users_total_usage_time_column: '',
      top_users_usage_time_column_unit_label: '',
    },
    area_charts: {
      general_system_usage_title: '',
      general_system_usage_subtitle: '',
      general_system_usage_x_label: '',
      general_system_usage_y_label: '',
      general_system_usage_y_unit_label: '',
    },
    bar_charts: {
      calls_evolution_title: '',
      calls_evolution_subtitle: '',
      calls_evolution_x_label: '',
      calls_evolution_y_label: '',
    },
    pie_charts: {
      most_used_applications_title: '',
      most_used_applications_subtitle: '',
      most_used_applications_x_label: '',
      most_used_applications_y_label: '',
      most_used_applications_y_unit_label: '',
    },
    stack_charts: {
      applications_usage_title: '',
      applications_usage_subtitle: '',
      applications_usage_x_label: '',
      applications_usage_singular_stack_label: '',
      applications_usage_plural_stack_label: '',
      applications_usage_y_label: '',
      applications_usage_y_unit_label: '',
    },
  },
  senior_statistics_dashboard: {
    title: '',
    refresh_button: '',
    statistics_per_application_title: '',
    statistics_per_application_application_label: '',
    statistics_per_application_entity_label: '',
    statistics_per_application_entity_placeholder: '',
    statistics_per_application_info_message: '',
    text_charts: {
      number_of_informal_caregivers_title: '',
      number_of_informal_caregivers_subtitle: '',
      number_of_pending_invites_title: '',
      number_of_pending_invites_subtitle: '',
      number_of_calls_title: '',
      number_of_calls_subtitle: '',
      number_of_outgoing_calls_title: '',
      number_of_outgoing_calls_subtitle: '',
      number_of_incoming_calls_title: '',
      number_of_incoming_calls_subtitle: '',
      average_daily_usage_last_title: '',
      average_daily_usage_subtitle: '',
      average_daily_usage_unit_label: '',
      number_of_media_received_title: '',
      number_of_media_received_subtitle: '',
      number_of_video_messages_received_title: '',
      number_of_video_messages_sent_title: '',
      number_of_photos_sent_title: '',
      number_of_drawings_sent_title: '',
      number_of_paintings_sent_title: '',
      last_access_date_time_title: '',
    },
    table_charts: {
      top_preferences_title: '',
      top_preferences_subtitle: '',
      top_preferences_application_column: '',
      top_preferences_total_usage_time_column: '',
      top_preferences_total_usage_time_column_unit_label: '',
    },
    area_charts: {
      general_system_usage_title: '',
      general_system_usage_subtitle: '',
      general_system_usage_x_label: '',
      general_system_usage_y_label: '',
      general_system_usage_y_unit_label: '',
      application_usage_title: '',
      application_usage_subtitle: '',
      application_usage_x_label: '',
      application_usage_y_label: '',
      application_usage_y_unit_label: '',
    },
    pie_charts: {
      most_used_applications_title: '',
      most_used_applications_subtitle: '',
      most_used_applications_x_label: '',
      most_used_applications_y_label: '',
      most_used_applications_y_unit_label: '',
    },
    stack_charts: {
      applications_usage_title: '',
      applications_usage_subtitle: '',
      applications_usage_x_label: '',
      applications_usage_singular_stack_label: '',
      applications_usage_plural_stack_label: '',
      applications_usage_y_label: '',
      applications_usage_y_unit_label: '',
    },
    line_charts: {
      application_evolution_title: '',
      application_evolution_subtitle: '',
      application_evolution_x_label: '',
      application_evolution_y_label: '',
    },
  },
  charts: {
    no_data: '',
  },
  media_gallery: {
    refresh: '',
    no_more_data: '',
    without_data: '',
  },
  application_category_form: {
    exit_button: '',
    create_application_category_title: '',
    save_button: '',
    saving_button: '',
    default_name_input: '',
    default_description_input: '',
    enabled_state_color_input: '',
    pressed_state_color_input: '',
    name_translations_input: '',
    description_translations_input: '',
    deleting_button: '',
    delete_button: '',
    delete_dialog_title: '',
    delete_dialog_content: '',
    delete_dialog_action_yes_button: '',
    delete_dialog_action_no_button: '',
    router_prompt_create_title: '',
    router_prompt_create_message: '',
    router_prompt_edit_title: '',
    router_prompt_edit_message: '',
    router_prompt_action_cancel_button: '',
    router_prompt_action_ok_button: '',
    edit_cancel_toast: '',
    create_cancel_toast: '',
    create_dialog_title: '',
    create_dialog_message: '',
    edit_dialog_title: '',
    edit_dialog_message: '',
    save_dialog_action_cancel_button: '',
    save_dialog_action_save_button: '',
    success: {
      save_success_button: '',
      delete_success_button: '',
      create_success_message: '',
      edit_success_message: '',
    },
    errors: {
      error_on_save_button: '',
      error_on_delete_button: '',
      edit_form_validation_invalid_field: '',
      create_form_validation_invalid_field: '',
      form_validation_invalid_color: '',
    },
  },
  playlist_types: {
    [PlaylistType.Karaoke]: '',
    [PlaylistType.Movies]: '',
    [PlaylistType.Music]: '',
  },
  playlists: {
    system_administrator: {
      root: {
        title: '',
        search_input_placeholder: '',
        type_filter: '',
        name_header: '',
        no_playlists: '',
        add_button: '',
        deleted_playlist_dialog_title: '',
        deleted_playlist_dialog_message: '',
        deleted_playlist_dialog_ok_button: '',
      },
      edit: {
        tabs: {details: '', items: '', entities: ''},
        items: {
          search_input_placeholder: '',
          title_header: '',
          no_items: '',
          add_button: '',
          deleted_playlist_item_dialog_title: '',
          deleted_playlist_item_dialog_message: '',
          deleted_playlist_item_dialog_ok_button: '',
        },
        entities: {
          search_input_placeholder: '',
          name_header: '',
          type_header: '',
          state_header: '',
          state_value_true: '',
          state_value_false: '',
          no_entities: '',
          enable_playlist_dialog_title: '',
          enable_playlist_dialog_message: '',
          enable_playlist_dialog_action_yes_button: '',
          enable_playlist_dialog_action_no_button: '',
          disable_playlist_dialog_title: '',
          disable_playlist_dialog_message: '',
          disable_playlist_dialog_action_yes_button: '',
          disable_playlist_dialog_action_no_button: '',
          errors: {
            enable_playlist_error_message: '',
            disable_playlist_error_message: '',
            update_state_playlist_error_message: '',
          },
        },
        errors: {playlist_does_not_exist_error: ''},
      },
      playlist_item: {
        tabs: {
          details: '',
          entities: '',
        },
        entities: {
          search_input_placeholder: '',
          name_header: '',
          type_header: '',
          state_header: '',
          state_value_true: '',
          state_value_false: '',
          no_entities: '',
          enable_item_dialog_title: '',
          enable_item_dialog_message: '',
          enable_item_dialog_action_yes_button: '',
          enable_item_dialog_action_no_button: '',
          disable_item_dialog_title: '',
          disable_item_dialog_message: '',
          disable_item_dialog_action_yes_button: '',
          disable_item_dialog_action_no_button: '',
          errors: {
            enable_item_error_message: '',
            disable_item_error_message: '',
            update_state_item_error_message: '',
          },
        },
        errors: {item_does_not_exist_error: ''},
      },
    },
    professional_caregiver: {
      root: {
        search_input_placeholder: '',
        type_filter: '',
        name_header: '',
        state_header: '',
        state_value_true: '',
        state_value_false: '',
        no_playlists: '',
        enable_playlist_dialog_title: '',
        enable_playlist_dialog_message: '',
        enable_playlist_dialog_action_yes_button: '',
        enable_playlist_dialog_action_no_button: '',
        disable_playlist_dialog_title: '',
        disable_playlist_dialog_message: '',
        disable_playlist_dialog_action_yes_button: '',
        disable_playlist_dialog_action_no_button: '',
        errors: {
          enable_playlist_error_message: '',
          disable_playlist_error_message: '',
          update_state_playlist_error_message: '',
        },
      },
      edit: {
        tabs: {
          items: '',
          users: '',
          details: '',
        },
        items: {
          search_input_placeholder: '',
          title_header: '',
          state_header: '',
          state_value_true: '',
          state_value_false: '',
          no_items: '',
          enable_item_dialog_title: '',
          enable_item_dialog_message: '',
          enable_item_dialog_action_yes_button: '',
          enable_item_dialog_action_no_button: '',
          disable_item_dialog_title: '',
          disable_item_dialog_message: '',
          disable_item_dialog_action_yes_button: '',
          disable_item_dialog_action_no_button: '',
          errors: {
            enable_item_error_message: '',
            disable_item_error_message: '',
            update_state_item_error_message: '',
          },
        },
        users: {
          search_input_placeholder: '',
          name_header: '',
          type_header: '',
          state_header: '',
          state_value_true: '',
          state_value_false: '',
          no_users: '',
          enable_playlist_dialog_title: '',
          enable_playlist_dialog_message: '',
          enable_playlist_dialog_action_yes_button: '',
          enable_playlist_dialog_action_no_button: '',
          disable_playlist_dialog_title: '',
          disable_playlist_dialog_message: '',
          disable_playlist_dialog_action_yes_button: '',
          disable_playlist_dialog_action_no_button: '',
          errors: {
            enable_playlist_error_message: '',
            disable_playlist_error_message: '',
            update_state_playlist_error_message: '',
          },
        },
        errors: {playlist_does_not_exist_error: ''},
      },
      playlist_item: {
        tabs: {
          users: '',
          details: '',
        },
        users: {
          search_input_placeholder: '',
          name_header: '',
          type_header: '',
          state_header: '',
          state_value_true: '',
          state_value_false: '',
          no_users: '',
          enable_item_dialog_title: '',
          enable_item_dialog_message: '',
          enable_item_dialog_action_yes_button: '',
          enable_item_dialog_action_no_button: '',
          disable_item_dialog_title: '',
          disable_item_dialog_message: '',
          disable_item_dialog_action_yes_button: '',
          disable_item_dialog_action_no_button: '',
          errors: {
            enable_item_error_message: '',
            disable_item_error_message: '',
            update_state_item_error_message: '',
          },
        },
        errors: {item_does_not_exist_error: ''},
      },
    },
  },
  user_playlists: {
    search_input_placeholder: '',
    type_filter: '',
    entity_filter: '',
    name_header: '',
    state_header: '',
    state_value_true: '',
    state_value_false: '',
    state_disabled_tooltip: '',
    no_playlists: '',
    no_affiliations_info_message: '',
    enable_playlist_dialog_title: '',
    enable_playlist_dialog_message: '',
    enable_playlist_for_entity_dialog_message: '',
    enable_playlist_dialog_action_yes_button: '',
    enable_playlist_dialog_action_no_button: '',
    disable_playlist_dialog_title: '',
    disable_playlist_dialog_message: '',
    disable_playlist_for_entity_dialog_message: '',
    disable_playlist_dialog_action_yes_button: '',
    disable_playlist_dialog_action_no_button: '',
    errors: {
      enable_playlist_error_message: '',
      disable_playlist_error_message: '',
      update_state_playlist_error_message: '',
    },
  },
  time_lapse_types: {
    [TimeLapseType.Custom]: '',
    [TimeLapseType.Last180Days]: '',
    [TimeLapseType.Last30Days]: '',
    [TimeLapseType.Last365Days]: '',
    [TimeLapseType.LastMonth]: '',
    [TimeLapseType.LastWeek]: '',
    [TimeLapseType.ThisMonth]: '',
    [TimeLapseType.ThisWeek]: '',
  },
  time_lapse: {
    dialog_title: '',
    range_label: '',
    start_text: '',
    end_text: '',
    to_text: '',
    cancel_button: '',
    confirm_button: '',
  },
  device_health: {
    no_data: '',
    last_recording: '',
    basic_information_section_title: '',
    wifi_section_title: '',
    networks_wifi_subsection_title: '',
    current_wifi_subsection_title: '',
    mobile_data_section_title: '',
    graphics_section_title: '',
    controllers_graphics_subsection_title: '',
    displays_graphics_subsection_title: '',
    system_section_title: '',
    battery_section_title: '',
    disks_section_title: '',
    operating_system_section_title: '',
    cpu_section_title: '',
    memory_section_title: '',
    applications_section_title: '',
    versions_section_title: '',
    request_tracking_section_title: '',
    cache_images_section_title: '',
    creation_date_label: '',
    expiration_date_label: '',
    entity_label: '',
    user_label: '',
    data_usage_label: '',
    ssid_label: '',
    quality_label: '',
    ip_address_label: '',
    is_data_usage_enabled_label: '',
    carrier_label: '',
    network_type_label: '',
    dialer_label: '',
    signal_strength_label: '',
    signal_strength_level_label: '',
    signal_strength_no: '',
    signal_strength_weak: '',
    signal_strength_fair: '',
    signal_strength_good: '',
    signal_strength_strong: '',
    brand_label: '',
    model_label: '',
    is_main_display_label: '',
    width_label: '',
    height_label: '',
    current_width_label: '',
    current_height_label: '',
    current_scale_factor_label: '',
    sku_label: '',
    serial_number_label: '',
    version_label: '',
    has_battery_label: '',
    is_battery_charging_label: '',
    is_battery_connected_to_power_label: '',
    battery_level_label: '',
    size_label: '',
    used_disks_label: '',
    available_label: '',
    mount_label: '',
    name_label: '',
    distribution_label: '',
    release_label: '',
    build_label: '',
    web_view_version_label: '',
    cores_label: '',
    used_memory_label: '',
    country_label: '',
    region_label: '',
    city_label: '',
    city_longitude_label: '',
    city_latitude_label: '',
    language_label: '',
    user_ip_address_label: '',
    yes_label: '',
    no_label: '',
    gb_unit_label: '',
    mb_unit_label: '',
    px_unit_label: '',
    agent_label: '',
    chrome_label: '',
    electron_label: '',
    launcher_binary_label: '',
    launcher_frontend_label: '',
  },
  operative_system_names: {
    [OperativeSystemName.Android]: '',
    [OperativeSystemName.Linux]: '',
    [OperativeSystemName.MacOS]: '',
    [OperativeSystemName.Other]: '',
    [OperativeSystemName.Windows]: '',
    [OperativeSystemName.iOS]: '',
  },
  mobile_network_types: {
    [MobileNetworkType.Unspecified]: '',
    [MobileNetworkType._1G]: '',
    [MobileNetworkType._2G]: '',
    [MobileNetworkType._3G]: '',
    [MobileNetworkType._4G]: '',
    [MobileNetworkType._5G]: '',
  },
  home: {
    refreshing: '',
    release_to_refresh: '',
    pull_to_refresh: '',
    none: {
      root: {
        no_associations_message_title: '',
        no_associations_message_subtitle: '',
      },
    },
  },
  localized_string_input: {
    cancel_button: '',
    confirm_button: '',
    has_zero_translations_tooltip_message: '',
    has_one_translation_tooltip_message: '',
    has_many_translations_tooltip_message: '',
  },
  user_playlist_items: {
    title: '',
    search_input_placeholder: '',
    title_header: '',
    state_header: '',
    state_value_true: '',
    state_value_false: '',
    state_disabled_tooltip: '',
    no_items: '',
    enable_item_dialog_title: '',
    enable_item_dialog_message: '',
    enable_item_dialog_action_yes_button: '',
    enable_item_dialog_action_no_button: '',
    disable_item_dialog_title: '',
    disable_item_dialog_message: '',
    disable_item_dialog_action_yes_button: '',
    disable_item_dialog_action_no_button: '',
    errors: {
      enable_item_error_message: '',
      disable_item_error_message: '',
      update_state_item_error_message: '',
      playlist_does_not_exist_error: '',
    },
  },
  playlist_form: {
    exit_button: '',
    create_playlist_title: '',
    save_button: '',
    saving_button: '',
    default_name_input: '',
    name_translations_input: '',
    default_description_input: '',
    description_translations_input: '',
    enabled_state_color_input: '',
    pressed_state_color_input: '',
    state_input: '',
    state_value_true: '',
    state_value_false: '',
    type_input: '',
    active_by_default_for_all_entities_input: '',
    active_by_default_for_all_entities_placeholder_input: '',
    yes_value: '',
    no_value: '',
    image_url_input: '',
    image_info_message: '',
    regional_lockout_input: '',
    regional_lockout_placeholder: '',
    deleting_button: '',
    delete_button: '',
    delete_dialog_title: '',
    delete_dialog_content: '',
    delete_dialog_action_yes_button: '',
    delete_dialog_action_no_button: '',
    save_dialog_action_cancel_button: '',
    save_dialog_action_save_button: '',
    router_prompt_create_title: '',
    router_prompt_create_message: '',
    router_prompt_edit_title: '',
    router_prompt_edit_message: '',
    router_prompt_action_cancel_button: '',
    router_prompt_action_ok_button: '',
    edit_cancel_toast: '',
    create_cancel_toast: '',
    success: {
      save_success_button: '',
      delete_success_button: '',
      create_success_message: '',
      edit_success_message: '',
    },
    errors: {
      error_on_save_button: '',
      error_on_delete_button: '',
      edit_form_validation_invalid_field: '',
      create_form_validation_invalid_field: '',
      form_validation_invalid_color: '',
    },
  },
  playlist_item_form: {
    exit_button: '',
    create_playlist_item_title: '',
    save_button: '',
    saving_button: '',
    deleting_button: '',
    delete_button: '',
    delete_dialog_title: '',
    delete_dialog_content: '',
    delete_dialog_action_yes_button: '',
    delete_dialog_action_no_button: '',
    create_dialog_title: '',
    create_dialog_message: '',
    save_dialog_action_cancel_button: '',
    save_dialog_action_save_button: '',
    router_prompt_create_title: '',
    router_prompt_create_message: '',
    router_prompt_edit_title: '',
    router_prompt_edit_message: '',
    router_prompt_action_cancel_button: '',
    router_prompt_action_ok_button: '',
    edit_cancel_toast: '',
    create_cancel_toast: '',
    default_title_input: '',
    title_translations_input: '',
    default_description_input: '',
    description_translations_input: '',
    regional_lockout_input: '',
    regional_lockout_placeholder: '',
    state_input: '',
    state_value_true: '',
    state_value_false: '',
    playlist_input: '',
    resource_url_input: '',
    resource_input: '',
    thumbnail_image_url_input: '',
    thumbnail_image_info_message: '',
    success: {
      save_success_button: '',
      delete_success_button: '',
      create_success_message: '',
      edit_success_message: '',
    },
    errors: {
      error_on_save_button: '',
      error_on_delete_button: '',
      edit_form_validation_invalid_field: '',
      create_form_validation_invalid_field: '',
      form_validation_invalid_resource_url: '',
    },
  },
  licenses: {
    professional_caregiver: {
      root: {
        refresh_button: '',
        number_of_monthly_active_licenses_title: '',
        number_of_active_seniors_title: '',
        number_of_monthly_active_licenses_not_defined: '',
      },
    },
  },
  videocall: {
    you: '',
    incomingCall: '',
    incomingCallConnecting: '',
    incomingCallConnectingHint: '',
    answer: '',
    decline: '',
    settingsTitle: '',
    settingsMicrophone: '',
    settingsCamera: '',
    settingsSpeaker: '',
    default: '',
    callFailed: {
      title: '',
      ok: '',
      e486: '',
      e487: '',
      e603: '',
      e404: '',
      e480: '',
      e402: '',
    },
  },
  entityFrontCardDesignTool: {
    title: '',
    step1: '',
    step2: '',
    step3: '',
    entityPicture: '',
    chooseAnotherEntityPicture: '',
    entityName: '',
    addEntityName: '',
    entityNameToBePrinted: '',
    entityNameTextColor: '',
    entityNameTextFont: '',
    next: '',
    save: '',
    restart: '',
    failedToLoadUsers: '',
  },
  entityBackCardDesignTool: {
    title: '',
    step1: '',
    step2: '',
    entityName: '',
    entityNumber: '',
    seniorUsersCount: '',
    caregiverUsersCount: '',
    cardName: '',
    entityPictureHeight: '',
    lineColor: '',
    includeEntityName: '',
    generatePreview: '',
    saveCards: '',
    saveSpreadsheet: '',
    restart: '',
  },
  cards: {
    pendingInvitation: '',
    years: '',
  },
  dashboard_side_menu: {
    dashboard: '',
    general_activity: '',
    statistics: '',
    general_statistics: '',
    social_statistics: '',
  },
  digital_inclusion_side_menu: {
    applications: '',
    details: '',
    users: '',
    photos: '',
    cards: '',
    devices: '',
    services: '',
    playlists: '',
  },
  seniorSideMenu: {
    generalStatistics: '',
    healthStatistics: '',
    basicActivitiesDailyLife: '',
    careAndActivity: '',
    individualPlan: '',
    personalData: '',
    careServices: '',
  },
  teamSideMenu: {
    professionals: '',
    shifts: {
      title: '',
      shiftsManagement: '',
      shiftsAllocations: '',
    },
    attendanceTracker: {
      title: '',
      assignments: '',
      registry: '',
    },
    careServices: '',
    permissions: '',
    profileDropdown: {
      profile: '',
      careServices: '',
      applications: '',
      cards: '',
      playLists: '',
    },
  },
  profileSideMenu: {
    profile: '',
  },
  settingsSideMenu: {
    institution: '',
    activities_sectors: {
      load_error: '',
    },
  },
  responsibleUserDropdown: {
    noResponsibleDefined: '',
    noCoordinatorDefined: '',
  },
  activities_group_entry: {
    modals: {
      edit: {
        title: '',
        observations_max_characters: '',
      },
      confirm_delete: {
        title: '',
        copy: {
          title: '',
          subtitle: '',
        },
      },
    },
    activity_types: '',
    no_activity_types: '',
    configuration_type_not_defined: '',
    configuration_type_label: '',
    exceptions: '',
    edit_details: '',
    add_activities: '',
    configure_first: '',
    actions: {
      exit: '',
      edit: '',
      delete: '',
      history: '',
    },
    snackbar: {
      create: {
        success: '',
        error: '',
      },
      update: {
        success: '',
        error: '',
      },
      delete: {
        success: '',
        error: '',
      },
      configuration: {
        success: '',
        error: '',
      },
    },
    error: '',
  },
  activities_type_entry: {
    modals: {
      edit: {
        title: '',
      },
      delete: {
        title: '',
        copy: {
          title: '',
          subtitle: '',
        },
      },
      view: {
        leave: '',
        view_only: '',
      },
    },
    snackbar: {
      update: {
        success: '',
        error: '',
      },
      delete: {
        success: '',
        error: '',
      },
      configuration: {
        success: '',
        error: '',
      },
    },
    templates: {
      name: '',
      description: '',
      activities_save: '',
      activities_import: '',
      check_all: '',
      snackbar: {
        success_message: '',
        error_message: '',
        import_success_message: '',
        import_error_message: '',
      },
      template: '',
      confirmation_title: '',
      confirmation_subtitle: '',
      confirmation_replace_title: '',
      confirmation_replace_subtitle: '',
      confirm: '',
      name_error: '',
      description_error: '',
      select: '',
    },
  },
  dynamic_form: {
    required_message: '',
    pattern_message: {
      invalid: '',
      max_characters: '',
    },
    error_loading: '',
    feature_fields: {
      autocomplete: {
        load_more: '',
        loading: '',
        no_options: '',
        placeholder: '',
        counter: '',
      },
    },
  },
  modal: {
    ok: '',
    cancel: '',
    confirm: '',
    add: '',
    save: '',
    remove: '',
    import: '',
    back: '',
    next: '',
    delete: '',
    revert: '',
    archive: '',
  },
  daily_care_log: {
    generics: {
      back: '',
    },
    senior_actions: {
      open_actions: '',
      title: '',
    },
    tabs: {
      home: '',
      occurrences: '',
      attendance_tracker: '',
    },
    date_carousel: {
      yesterday: '',
      today: '',
      tomorrow: '',
    },
    task_table: {
      tasks: '',
      empty: '',
      select_all: '',
      sort: '',
      drawer: {
        clear: '',
        save: '',
        filters: {
          title: '',
          social_responses: '',
        },
        sort: {
          title: '',
          name: '',
          autonomy: '',
          status: '',
          ascending: '',
          descending: '',
        },
      },
    },
    cards: {
      entity_user: {
        task_conclusion_summary_label: {
          concluded: '',
          task: '',
        },
      },
    },
    home: {
      my_shifts: '',
      care_services: '',
      other_shifts: '',
      no_allocated_shifts: '',
      no_other_shifts: '',
      no_care_services: '',
      previous_days_shift: '',
    },
    seniors: {
      title: '',
      no_seniors: '',
    },
    task_details: {
      task_not_done_reason: '',
      task_done: '',
      task_not_done: '',
      add_a_note: '',
      cancel: '',
      save: '',
      register: '',
      edit: '',
      edit_entry: '',
      disabled_tooltip: '',
    },
    shift_collapsible: {
      shift: '',
      other_shift_members: '',
      no_other_shift_members: '',
    },
    shift_details: {
      all_tasks_handled: '',
      tabs: {
        simple: {title: ''},
        grouped: {title: '', task: ''},
        user: {
          title: '',
          grid: {
            empty: '',
            empty_search_message: {
              title: '',
              subtitle: '',
            },
          },
        },
      },
      unplanned_tasks: {
        header_title: '',
        activity_sector: '',
        activity: '',
        name: '',
        execution_date: '',
        execution_hour: '',
        add_success_toast: '',
        add_error_toast: '',
        upload_error_toast: '',
        add_multiple_success_toast: '',
        add_cancel_modal_title: '',
        add_cancel_modal_subtitle: '',
        add_user_placeholder: '',
        add_files: '',
        delete_attachment: '',
        files_size: '',
        file_size_error: '',
        file_not_supported_error: '',
        file_both_errors: '',
      },
    },
    grouped_tasks_details: {
      select_bottom_bar: {
        count: '',
        count_plural: '',
        next: '',
      },
    },
    grouped_tasks_handling: {
      snackbar: {
        loading_tasks: {
          error: '',
        },
        updating_tasks: {
          success: '',
          error: '',
        },
      },
    },
    attendance_tracker: {
      title: '',
      empty_title: '',
      empty_subtitle: '',
      register: '',
      filters: {
        sections: {
          attendanceMovements: '',
          attendanceStatus: '',
          attendancePeriods: '',
        },
        values: {
          voided: '',
          entry: '',
          exit: '',
          open: '',
          closed: '',
          morning: '',
          afternoon: '',
          night: '',
        },
      },
      session: {
        entry: '',
        exit: '',
        running: '',
        overdue: '',
        closed: '',
        elapsed: '',
        overdue_alert: '',
        total: '',
      },
      bar: {
        running: '',
        since: '',
        not_started: '',
      },
      manual: {
        registered_by: '',
        entry_registered_by: '',
        exit_registered_by: '',
        notice: '',
        reason: '',
        no_location: '',
        unknown_user: '',
      },
      voided: {
        tag: '',
        notice: '',
        reason: '',
      },
      register_entry: '',
      register_exit: '',
      load_error: '',
      empty_other_day: '',
      details: {
        no_exit: '',
        open_in_maps: '',
        time_zone: '',
      },
      new: {
        title_entry: '',
        title_exit: '',
        save_entry: '',
        save_exit: '',
        record_type: '',
        entry: '',
        exit: '',
        professional: '',
        entity: '',
        date_time: '',
        location: '',
        latitude: '',
        longitude: '',
        accuracy: '',
        accuracy_value: '',
        waiting: '',
        accuracy_info: '',
        unavailable: '',
        loading_error: '',
        retry: '',
        success_entry: '',
        success_exit: '',
        type_conflict: '',
        save_error: '',
        purpose: '',
        permission: {
          prompt_title: '',
          prompt_description: '',
          allow: '',
          denied_title: '',
          denied_description: '',
          unsupported_title: '',
          unsupported_description: '',
          help: {
            chrome: '',
            edge: '',
            firefox: '',
            safari: '',
            ios: '',
            android_chrome: '',
            generic: '',
          },
        },
      },
    },
    occurrences: {
      empty_title: '',
      empty_filters_title: '',
      empty_subtitle: '',
      new: '',
      new_occurrence: '',
      add: '',
      type: '',
      date: '',
      time: '',
      local: '',
      responsible: '',
      patient: '',
      details: '',
      add_success_toast: '',
      add_error_toast: '',
      add_cancel_modal_title: '',
      add_cancel_modal_subtitle: '',
      local_error: '',
    },
  },
  care_and_activities: {
    date: '',
    activity: '',
    task: '',
    evaluation: '',
    responsible: '',
    status: '',
    empty_state: '',
    permissions: '',
    register: '',
    notes: '',
    status_types: {
      [CaregiverTaskCompletion.DONE]: '',
      [CaregiverTaskCompletion.NOT_DONE]: '',
      [CaregiverTaskCompletion.PLANNED]: '',
      [CaregiverTaskCompletion.MISSED]: '',
    },
    sort_icon: {
      sort_in_ascending: '',
      sort_in_descending: '',
    },
    handle_task_modal: {
      task_status: {
        done: '',
        not_done: '',
      },
      details: '',
      observations: '',
      treated: '',
      cancel: '',
      write_observation: '',
      observation_required_message: '',
      card_collapse: {
        title: '',
      },
      time_input: '',
      date_input: '',
      select_date: '',
      select_time: '',
      task_info_load_error: '',
      feature_input: {
        label: {
          [CareTaskFeature.BloodGlucoseHealthMeasurement]: '',
          [CareTaskFeature.BloodOxygenHealthMeasurement]: '',
          [CareTaskFeature.BloodPressureHealthMeasurement]: '',
          [CareTaskFeature.BodyFatPercentageHealthMeasurement]: '',
          [CareTaskFeature.BodyHeightHealthMeasurement]: '',
          [CareTaskFeature.BodyMusclePercentageHealthMeasurement]: '',
          [CareTaskFeature.BodyTemperatureHealthMeasurement]: '',
          [CareTaskFeature.BodyWaterPercentageHealthMeasurement]: '',
          [CareTaskFeature.BodyWeightHealthMeasurement]: '',
          [CareTaskFeature.HeartRateHealthMeasurement]: '',
          [CareTaskFeature.NatriureticPeptideTestHealthMeasurement]: '',
          [CareTaskFeature.RespiratoryRateHealthMeasurement]: '',
          [CareTaskFeature.SleepHealthMeasurement]: '',
          [CareTaskFeature.StepsHealthMeasurement]: '',
        },
        inputs: {
          value: {
            label: '',
            placeholder: '',
          },
          minutes: {
            label: '',
            placeholder: '',
          },
          percentage: {
            label: '',
            placeholder: '',
          },
          mealTime: {
            label: '',
            placeholder: '',
            options: {
              'before-meal': '',
              'after-meal': '',
            },
          },
          bnp: {
            label: '',
            placeholder: '',
          },
          nt_proBnp: {
            label: '',
            placeholder: '',
          },
          type: {
            label: '',
            placeholder: '',
            options: {
              'in-bed': '',
              awake: '',
              rem: '',
              core: '',
              deep: '',
            },
          },
          startTime: {
            label: '',
          },
          endTime: {
            label: '',
          },
        },
        units: {
          steps: '',
        },
        required_message: '',
        number_pattern_validation: {
          min: '',
          max: '',
        },
      },
      undo_task: '',
      undo: '',
      edit_entry: '',
      confirm: '',
      snackbar: {
        update: {
          success: '',
          error: '',
        },
        reset: {
          success: '',
          error: '',
        },
      },
      history: {
        title: '',
        update: '',
        status: '',
        someone: '',
        remove: '',
        auto: '',
        validate: '',
        create: '',
        read: '',
        contract_update: '',
        changes: '',
        task_not_done_reason: '',
        notes: '',
        files_added: '',
        files_removed: '',
      },
      files: '',
    },
  },
  configurations_fields: {
    feature: {
      name: {
        placeholder: '',
      },
    },
  },
  schedule_modal: {
    trigger_button_label: '',
    activity: {
      title: '',
    },
    task: {
      title: '',
    },
  },
  schedule_field: {
    readable_periodicity: {
      not_defined: '',
      no_repetition: '',
      defined_per_activity: '',
      at_every: '',
      hourly: '',
      daily: '',
      weekly: '',
      monthly: '',
      weekly_at: '',
      and: '',
      at_hour: '',
      until_end_day: '',
    },
    quantities: '',
  },
  activity_type_posology_schedule_form: {
    title: '',
    fields: {
      psology: {
        label: '',
      },
      posology_schedule_type: {
        label: '',
        options: {
          [PosologySchedule.Repetition]: '',
          [PosologySchedule.PeriodsOfTheDay]: '',
          [PosologySchedule.TimesList]: '',
          [PosologySchedule.SOS]: '',
        },
      },
      frequency: {
        options: {
          [Frequency.Hourly]: '',
          [Frequency.Daily]: '',
          [Frequency.Weekly]: '',
          [Frequency.Monthly]: '',
        },
      },
      frequency_value: {
        label: '',
        validations: {
          min: '',
        },
      },
      time_list: {
        hour: {
          label: '',
        },
        quantity: {
          label: '',
        },
        add: '',
        required: '',
        error: '',
      },
      periods_of_the_day_item: {
        required: '',
      },
      repetitionHourlyFrequencyValue: '',
      repetitionHourlyFrequencyValueHour: '',
      repetitionHourlyFrequencyValueHours: '',
      repetition_quantity: {
        label: '',
        validations: {
          min: '',
        },
      },
      end_date: {
        label: '',
        validations: {
          min: '',
        },
      },
      end_hour: {
        label: '',
        validations: {
          min: '',
        },
      },
    },
  },
  care_plan_sheet_activities_group_entry_configurationvalue: {
    repetition: {
      per_activity: '',
      per_task: '',
    },
    aivd: {
      at_time: '',
      transportation: '',
    },
  },
  periodicity_form: {
    empty_state: '',
    fields: {
      frequency: {
        label: '',
        hourly: '',
        daily: '',
        weekly: '',
        monthly: '',
      },
      frequency_value: {
        label: '',
        activity: '',
        task: '',
        validations: {
          required: '',
          min: '',
          max: '',
        },
      },
      start_at_date: {
        label: '',
        validations: {
          superior_to_end_date: '',
        },
      },
      end_date: {
        label: '',
        validations: {
          superior_to_start_date: '',
        },
      },
      end_hour: {
        label: '',
      },
      days: {
        label: '',
        validations: {
          required: '',
        },
      },
    },
  },
  role_permissions_professional_caregiver_office_screen: {
    generic_header: {
      subtitle: '',
    },
    fields: {
      name: {label: '', placeholder: ''},
      description: {label: '', placeholder: ''},
    },
    view: {
      tooltip: '',
      label: '',
    },
    edit: {
      tooltip: '',
      label: '',
    },
    select_all_permissions: '',
    localized_string_input: {
      name: {
        title: '',
      },
      description: {
        title: '',
      },
    },
    router_prompt: {
      title: '',
      content: {
        title: '',
        subtitle: '',
      },
    },
    snackbar: {
      load: {
        error: '',
      },
      update: {
        success: '',
        error: '',
      },
      exit: '',
    },
  },
  shifts_page: {
    shifts: '',
    team: '',
    create_button: '',
    schedule: '',
    to_hour: '',
    responsible: {
      label: '',
      not_defined: '',
    },
    professionals: {
      singular: '',
      plural: '',
    },
    teams: {
      singular: '',
      plural: '',
    },
    empty_state: {
      title: '',
      subtitle: '',
    },
    shift_modal: {
      create_shift: '',
      edit_shift: '',
      shift_form: {
        name: '',
        name_placeholder: '',
        required_field_message: '',
        min_required_field_message: '',
        pattern_field_message: '',
        max_characters_name_message: '',
        abbreviation: '',
        abbreviation_placeholder: '',
        color: '',
        social_response: '',
        social_responses_placeholder_input: '',
        people_per_shift: '',
        people_per_shift_placeholder_input: '',
        start_hour: '',
        end_hour: '',
        shift_responsible: '',
        shift_responsible_placeholder: '',
        snackbar: {
          create_shift: {
            success: '',
            error: '',
          },
          update_shift: {
            success: '',
            error: '',
          },
        },
      },
    },
    confirm_delete: {
      title: '',
      copy: {
        title: '',
        subtitle: '',
      },
    },
    cancel: '',
    create: '',
    save: '',
    delete: '',
  },
  planner: {
    header: {
      title: '',
      filter_all_seniors_label: '',
      filter_input_placeholder: '',
      range: {
        day: '',
        week: '',
        month: '',
      },
      add: '',
      add_disabled: '',
      toggler: {
        list: '',
        calendar: '',
      },
    },
    body: {
      untreaten: '',
      untreaten_one: '',
      untreaten_other: '',
      empty: '',
    },
    side: {
      see_all: '',
      birthdays: '',
    },
    modal: {
      create: {
        activity: {
          ativities_group: '',
          ativities_group_placeholder: '',
          activities_type: '',
          activities_type_placeholder: '',
          add_users_label: '',
          add_users_placeholder: '',
          added_users: '',
          add_users_type: {
            social_response: '',
            user: '',
          },
          add_users_mark: '',
          add_users_mark_one: '',
          add_users_mark_other: '',
          add_users_mark_all: '',
          success: '',
          success_one: '',
          success_other: '',
        },
      },
      delete: {
        title: {
          single: '',
          multiple: '',
        },
        desc: {
          single: '',
          multiple: '',
        },
      },
    },
    item_menu: {
      activity: {
        users: '',
        action: {
          delete: '',
          delete_disabled: '',
          edit: '',
          plan: '',
          register: '',
        },
      },
      anniversary: {
        birthday: '',
        born: '',
        years: '',
      },
    },
    errors: {
      content: '',
      save_activity: '',
      delete_activity: '',
      unknown_item_type: '',
    },
  },
  care_services: {
    header: {
      add_button_disabled_tooltip: '',
      seniors_label: '',
      filter_caregivers_label: '',
    },
    form: {
      required_field_message: '',
      title_label: '',
      title_placeholder: '',
      color_label: '',
      start_date_label: '',
      end_date_label: '',
      start_time_label: '',
      end_time_label: '',
      repetition_label: '',
      responsible_users_label: '',
      responsible_users_placeholder: '',
      senior_label: '',
      senior_placeholder: '',
      notes_label: '',
      notes_placeholder: '',
      permissions_disabled_tooltip: '',
      twenty_four_hours_label: '',
    },
    modals: {
      edit: {
        title: '',
      },
      create: {
        title: '',
      },
      delete: {
        title: '',
        description: '',
        cannot_be_undone: '',
      },
      repetition_options: {
        only_this_event: '',
        this_and_following: '',
      },
      edit_recurrent: {
        title: '',
      },
      delete_recurrent: {
        title: '',
      },
      edit_confirmation: {
        title: '',
        subtitle: '',
      },
    },
    toasts: {
      edit: {
        success: {
          title: '',
          message: '',
        },
        error: {
          unknown: {
            title: '',
            message: '',
          },
          not_found: {
            title: '',
            message: '',
          },
          access_denied: {
            title: '',
            message: '',
          },
          invalid_data: {
            title: '',
            message: '',
          },
          end_date_invalid: {
            title: '',
            message: '',
          },
          repetition_required: {
            title: '',
            message: '',
          },
          repetition_removal_scope: {
            title: '',
            message: '',
          },
          repetition_change_scope: {
            title: '',
            message: '',
          },
        },
      },
      create: {
        success: {
          title: '',
          message: '',
        },
        error: {
          title: '',
          message: '',
        },
      },
      delete: {
        error: {
          title: '',
          message: '',
        },
      },
    },
    export: {
      repetition: {
        ends_on: '',
        ends_after: '',
        occurrences: '',
      },
    },
    permissions: {
      view: '',
    },
  },
  shared: {
    handle_care_task_modal: {
      confirm_edit: {
        title: '',
      },
      confirm_edit_cancel: {
        title: '',
        subtitle: '',
      },
      confirm_reset: {
        title: '',
        subtitle: '',
      },
    },
    input_disabled_tooltip: '',
  },
  export: {
    plan: '',
    address: '',
    contributor_number: '',
    sns_number: '',
    contact: '',
    others: '',
    details: '',
    tasks: '',
    task: '',
    register: '',
    date: '',
    start_date: '',
    end_date: '',
    periodicity: '',
    observations: '',
    no_records: '',
    no_repetition: '',
    senior_profile: {
      save_pdf: '',
      report_title: '',
      user_section_title: '',
      profile_section_subtitle: '',
      full_name: '',
      preferred_name: '',
      birth_date: '',
      sns_number: '',
      social_security_number: '',
      taxpayer_number: '',
      additional_information: '',
      health_conditions_subtitle: '',
      food_intolerances_title: '',
      food_intolerances_subtitle: '',
      medication_allergies_subtitle: '',
      medication_title: '',
      latest_vital_signs_title: '',
    },
    error: {
      pdf_generation: '',
      xlsx_generation: '',
      pdf_monthly_not_supported: '',
    },
  },
};
export const translations: LanguageTranslation = writePaths(_translations, []);
